var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "map-component" }, [
    _c(
      "div",
      { staticClass: "map-title" },
      [
        _c("span", [
          _vm._v(_vm._s(_vm.$t("homePage.globalActivityDashboard")))
        ]),
        _c("Information", { attrs: { iconTheme: "light" } }, [
          _c("div", { staticClass: "hint-read-more" }, [
            _c("p", { staticClass: "margin-bottom" }, [
              _vm._v(_vm._s(_vm.$t("homePage.globalActivityDashboardHint")))
            ]),
            _c(
              "a",
              {
                attrs: { href: "#", id: "readMore" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.openFaq.apply(null, arguments)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("homePage.readMore")))]
            )
          ])
        ])
      ],
      1
    ),
    _c("div", { staticClass: "map-container" }, [
      _c("div", { staticClass: "map" }, [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "1200",
              height: "600",
              viewBox: "30.767 241.591 784.077 458.627"
            }
          },
          [
            _c("g", { attrs: { id: "United Arab Emirates" } }, [
              _c("title", [_vm._v("United Arab Emirates")]),
              _c("path", {
                attrs: {
                  id: "232",
                  d:
                    "M528.466 468.135l.753 3.008 8.52.752.597-6.172 1.644-.897.45-2.257-2.69.752-2.99 4.52-6.284.293z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Afghanistan" } }, [
              _c("title", [_vm._v("Afghanistan")]),
              _c("path", {
                attrs: {
                  id: "1",
                  d:
                    "M545.85 435.383l1.374 10.77 3.423.753.32 1.937-2.455 2.05 4.573 3.69 8.885-3.198.71-3.786 5.592-3.492 2.145-8.09 1.6-1.723-1.66-2.887 5.412-3.347-.692-.967-2.498.155-.226 2.3-3.354-.034-.062-3.068-1.08-1.288-1.814 1.65.052 1.514-2.74 1.036-5.058-.32-6.568 6.882-5.88-.537z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Albania" } }, [
              _c("title", [_vm._v("Albania")]),
              _c("path", {
                attrs: {
                  id: "2",
                  d:
                    "M450.68 420.438v3.984l1.14 2.152.82-.096 1.41-2.566-.82-1.15-.32-2.844-1.09-1.012-1.14 1.532z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Armenia" } }, [
              _c("title", [_vm._v("Armenia")]),
              _c("path", {
                attrs: {
                  id: "16",
                  d:
                    "M507.47 420.55l4.15 5.41-1.22 1.427-2.938-.51-3.646-3.268.196-2.147 3.458-.914z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Angola" } }, [
              _c("title", [_vm._v("Angola")]),
              _c("path", {
                attrs: {
                  id: "7",
                  d:
                    "M435.577 544.453l1.504 1.953 1.946-1.842-.57-1.91-.484-.034-2.395 1.833z M437.366 547.46l2.948 11.004-.07 3.478-4.312 4.633-.647 7.527 16.597.147 5.395 1.953 4.45-.58-2.594-3.25.01-9.283 5.1-.217v-3.62l-4.14-.173-.83-8.575-1.746.024-.943-.85-1.027.055-1.365 2.646h-5.255l-1.22-1.226.363-1.738-1.436-2.1-9.278.145z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Argentina" } }, [
              _c("title", [_vm._v("Argentina")]),
              _c("path", {
                attrs: {
                  id: "10",
                  d:
                    "M264.745 687.564l.225 4.95 3.803-.336 3.242-2.144-5.48-1.124-1.79-1.346z M279.05 600.613l1.677 1.57-6.37 9.468-2.24 2.48.777 10.813 4.918 5.974-4.132 7.21-3.13 1.35h-3.578l1.003 5.626-5.593 1.92 1.34 4.73-3.354 10.7 4.14 3.38-2.238 5.515-3.804 5.975 2.014 4.165-4.918.786-4.028-4.95-.674-15.433-6.258-26.208 1.893-9.163-4.028-11.714 2.68-15.204 2.463-2.93-.605-2.223 3.164-2.89 7.053.484 3.942 4.21 4.555.078 4.668 2.853-1.375 3.217.33 3.25 6.61-.312 3.097-4.727z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Austria" } }, [
              _c("title", [_vm._v("Austria")]),
              _c("path", {
                attrs: {
                  id: "12",
                  d:
                    "M430.46 403.46l-.562 1.166.483.83 2.016-.415h1.71l1.858 1.573 3.95-.717 2.904-1.73.743-1.166-.11-1.504-2.612-1.954-3.5.035-.295 1.988-3.683 1.797-2.9.097z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Australia" } }, [
              _c("title", [_vm._v("Australia")]),
              _c("path", {
                attrs: {
                  id: "11",
                  d:
                    "M728.775 668.09l-1.53 6.18.303 4.322 4.6-.312 5.212-8.03-8.585-2.16z M672.96 609.067l-.302 21.938-3.37 2.472-.304 2.16 4.598 3.087 11.35-2.16h5.826l2.145-3.096 12.88-2.472 9.197 2.784-.614 3.708 1.228 3.708 7.055-1.236.302 1.85-4.6 3.397 1.53 1.236 3.37-1.236-.916 10.2 6.44 4.944 3.683-1.235 1.84 1.852 10.735-1.548 10.123-16.382 3.682-.925 7.357-13.596 1.84-11.74-4.598-5.868 1.84-1.237-3.683-11.436-3.984-2.783.614-15.448-3.684-2.782-.916-8.652h-1.842l-6.138 20.392-3.37.312-7.668-7.728 4.296-11.437-7.97-1.546-8.897 2.472-2.455 7.104-3.984.925-.303-4.944-16.252 9.89.304 3.708-2.455 3.397h-6.14l-13.19 5.56-4.604 12.392z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Azerbaijan" } }, [
              _c("title", [_vm._v("Azerbaijan")]),
              _c("path", {
                attrs: {
                  id: "9",
                  d:
                    "M508.93 418.674l-.872 1.486 4.07 5.342 1.42-.458 2.333 2.446 1.012-4.287 2.533.406-.104-1.23-4.164-3.646-.795 2.143-5.43-2.203z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Bosnia and Herzegovina" } }, [
              _c("title", [_vm._v("Bosnia and Herzegovina")]),
              _c("path", {
                attrs: {
                  id: "23",
                  d:
                    "M442.708 411.084l-.32.527 5.802 5.982 2.127-3.13-.078-1.234-1.858-2.256-5.674.112z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Bangladesh" } }, [
              _c("title", [_vm._v("Bangladesh")]),
              _c("path", {
                attrs: {
                  id: "15",
                  d:
                    "M616.256 457.908l-1.134 2.05 2.938 5.583.087 4.358.535 1.166 3.45.06 1.952-1.874 1.418.855.285 2.652 1.133-.708.07-3.39-.952-.112-.596-2.88-2.403-.085-.597-1.6 1.47-1.962.023-.97h-4.27l-3.41-3.142z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Belgium" } }, [
              _c("title", [_vm._v("Belgium")]),
              _c("path", {
                attrs: {
                  id: "19",
                  d:
                    "M414.02 391.704l-.555 1.383 5.947 3.925.4.05.375-1.093.837-.59-1.336-1.498h-.916l-1.255-1.426-3.498-.752z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Burkina Faso" } }, [
              _c("title", [_vm._v("Burkina Faso")]),
              _c("path", {
                attrs: {
                  id: "250",
                  d:
                    "M404.493 493.496l3.146-.25 5.16 7.295-4.79 3.614-3.466-.892-4.66.062-.752 2.73-3.907.19-1.07-1.46 1.384-4.443 8.953-6.844z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Bulgaria" } }, [
              _c("title", [_vm._v("Bulgaria")]),
              _c("path", {
                attrs: {
                  id: "32",
                  d:
                    "M457.092 414.066l.14 4.305 1.45 3.026 5.455.095 2.455-1.736 2.412-.96-.588-2.75.545-1.468-1.227-.64-1.687.138-1.323 1.332-5.55.043-2.08-1.384z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Burundi" } }, [
              _c("title", [_vm._v("Burundi")]),
              _c("path", {
                attrs: {
                  id: "34",
                  d:
                    "M478.504 538.385l3.69-.078-.958 3.232-.935.81h-1.14l-.813-2.186.157-1.78z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Benin" } }, [
              _c("title", [_vm._v("Benin")]),
              _c("path", {
                attrs: {
                  id: "61",
                  d:
                    "M411.512 515.288h1.833l.104-5.204 2.314-3.363-.104-5.85-2.102-.053-3.604 2.816 1.504 2.87.054 8.785z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Brunei Darussalam" } }, [
              _c("title", [_vm._v("Brunei Darussala")]),
              _c("path", {
                attrs: {
                  id: "31",
                  d: "M689.038 515.08l-2.49 3.018 2.04.64 1.15-1.607-.7-2.05z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Bolivia" } }, [
              _c("title", [_vm._v("Bolivia")]),
              _c("path", {
                attrs: {
                  id: "22",
                  d:
                    "M238.63 561.36l7.115-3.103 2.35.226 1.566 6.534 10.84 3.604 1.79 5.524 4.47.562 1.9 4.73-1.34 4.277-7.27.562-2.68 6.872-5.704-.112-1.79-.337-3.293 3.197-1.625-.156-5.593-12.958 1.547-2.316.545-9.163-1.383-5.455-1.443-2.487z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Brazil" } }, [
              _c("title", [_vm._v("Brazil")]),
              _c("path", {
                attrs: {
                  id: "26",
                  d:
                    "M286.63 618.464l5.403-10.39.198-8.73 10.08-6.502h5.645l4.435-7.512.804-14.418-1.815-3.855 10.683-9.75.406-10.762-14.515-7.105-17.53-5.48-8.264-.812 2.222-4.67-.604-7.103-1.808-.596-2.67 5.307-1.4 1.754-3.596-1.59-12.093 4.262-4.027-5.073.648-5.3-3.803 3.872-4.2-2.265-.425.597.01 1.84 3.62 1.946-5.436 5.73-3.432-.034-3.475-3.535-3.934.122-.484 4.2 2.256 2.74-2.663 8.53-3.112.242-4.953 3.13-1.21 6.146 4.296 4.6.787-.89 3.017-.813 2.576 4.34 7.374-3.164 2.86.165 1.972 6.976 10.52 3.337 1.815 5.565 4.478.537 2.135 5.314-1.443 4.73 1.884 2.473-.275 3.682 5.048-.477 4.625 5.844-.363 4.104 2.74 2.316-6.57 9.95 11.566 6.474z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Bahamas" } }, [
              _c("title", [_vm._v("Bahamas")]),
              _c("path", {
                attrs: {
                  id: "13",
                  d:
                    "M222.12 463.112l-1.088-.337-.086 2.1 1.34 1.35.917-1.35-1.082-1.763zM224.29 466.397l-1.504.838 1.417 2.02.752-1.01-.665-1.848zM229.14 467.91l-1.59-.087.164 1.012 1.167 1.687 1.003-1.1-.743-1.512zM228.388 465.896l-2.593-1.1-.5-2.608 1-.425 1.004 2.023 1 .76.088 1.35zM225.88 460.588l-1.34-.337-.25-1.685-1.417-.5.917-.927 1.668.588 1.253.762-.83 2.1z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Bhutan" } }, [
              _c("title", [_vm._v("Bhutan")]),
              _c("path", {
                attrs: {
                  id: "21",
                  d: "M616.108 453.56l1.34 1.834 4.528.034-.458-2.507-5.41.64z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Botswana" } }, [
              _c("title", [_vm._v("Botswana")]),
              _c("path", {
                attrs: {
                  id: "24",
                  d:
                    "M454.56 594.59l1.858.57-.26 5.313 1.91.26 4.392-3.96 5.273.57 1.4-3.544 6.672-6.096-8.013-9.223-.104-1.513-.883-.26-2.43 2.24-6.31.154-.884 7.867-2.478.57-.142 7.052z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Belarus" } }, [
              _c("title", [_vm._v("Belarus")]),
              _c("path", {
                attrs: {
                  id: "35",
                  d:
                    "M456.418 382.86l1.297 2.136-.52 1.703.087 1.348.476 1.616 2.68-1.52 3.33.085 2.333.958h5.923l1.73-4.14 1.036-1.565v-1.045l-3.718-5.23-3.285-1.305-2.68-.303-2.335.743.088 2.35-3.24 4.1-3.202.068z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Belize" } }, [
              _c("title", [_vm._v("Belize")]),
              _c("path", {
                attrs: {
                  id: "27",
                  d:
                    "M191.823 483.228l-.043 3.154h.726l2.472-4.615H193.3l-1.477 1.46z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Canada" } }, [
              _c("title", [_vm._v("Canada")]),
              _c("path", {
                attrs: {
                  id: "38",
                  d:
                    "M130.684 350.117l-1.47 2.818.51 1.996.96.6-.226.81-1.03.295.295 2.965 1.106 1.115.88-.96-1.105-2.886.657-2.3 1.616-2.152-1.175-1.997-1.02-.303zM135.542 367.008l-1.323.52 2.428 2.818.588 3.336 2.43 2.592 2.057-.37v-3.407l-2.498-1.557-3.683-3.932zM268.15 295.833l-1.53 1.547 1.34 2.126 6.328.77-4.028-4.252-2.11-.19zM191.105 270.143l.19 3.475-6.898 7.148 1.73 5.79 4.978-1.347 2.878-4.254 7.278-2.706 5.94-.39-4.6-5.02-2.3 1.736-1.728-.58-.96-2.125-2.108-2.125-4.4.398zM200.113 259.908l-1.53 2.706 7.477 2.706 2.68-4.055 1.15 2.707h1.92l3.638-4.055-4.41-1.158-1.728-1.35-2.3 2.317-6.897.18zM213.148 265.318l-5.938 2.508v1.928l7.667 2.896-1.73 1.928 1.15 2.507 4.79-2.126h4.028l1.92 3.085 3.258-3.285-.77-3.095-2.68.968-.38-3.863 1.34-2.316h-1.34l-2.11 1.35-.958.768.58 2.707-1.53 1.157-2.3-.19-.58-3.476-4.417-3.452zM221.005 259.33l-.58 1.926 3.64 1.738 2.68-1.547-.19-1.158-5.55-.96zM223.875 256.044l-2.68.968.19 1.35 5.94-.39-.19-1.348-3.26-.58zM236.72 259.33l-.38 1.347-.96 1.35v1.928l3.64-.58 3.83 3.286h1.34v-3.284l-3.83-4.253-3.64.206zM246.497 263.19l1.53 1.74-1.34 2.315.96 2.507 4.217-2.317V265.7l-2.49-2.897-2.877.388zM252.055 258.75l.19 3.086h5.178l1.34 1.158-.19 1.348-4.6.58 3.26 4.443 4.41.77 6.127-2.705-8.817-13.33-2.68 1.738.19 2.316-3.07-1.158-1.338 1.754zM207.4 280.576l-7.28 1.928-4.218 3.673.38 4.054 7.667 2.318-1.73 3.864-5.558-3.477-1.53 2.896 3.64 2.508-.19 4.054 5.557 1.547 6.707-.39 1.15-2.126 4.978 5.6 3.45-1.156.578-3.864 2.49 1.737.38-3.863-3.068-1.928.19-12.163-2.68-2.126-2.87 3.865-8.046-6.95zM230.782 289.073l-2.49-1.158-1.34 1.737 2.68 4.253.19 4.054 5.75-3.476v-5.022l2.11-2.126-2.11-1.547h-3.45l-1.34 3.283zM243.048 287.335l-4.028 3.285.96 4.054h2.49l1.148-2.126 1.73 1.737 1.728-.19 4.6-3.864-8.628-2.895zM242.66 280.956l-.96 1.928 4.218 1.548 1.15-1.738-4.41-1.738zM240.17 273.617l-4.22.58-2.49 2.314 4.6.19-1.34 3.476.96 1.548 1.34-.19 3.258-5.212-2.11-2.705zM247.456 272.27l-2.3.77.38 3.086 3.83 2.507.19 1.927-1.148 1.16.58 3.863 14.754 4.823 4.028 1.35 4.028-3.476-4.79-3.864-4.408 1.158-6.128-.58-2.3-2.315-.578-6.372-3.83-1.928-2.308-2.11zM259.523 292.357l-4.218-.39-4.98 1.927-2.68 3.666.77 10.043 8.238.39 7.857 3.864 5.56 6.37 4.217-.19-1.15 5.982-3.83 6.37-4.217 1.926-3.07-.578-1.53-1.348-2.298 3.086.96 3.086 3.258.19 4.028-1.93 3.45 8.887 8.625 5.602 5.938-7.53-4.978-8.107 2.878-3.284 4.028 6.76 7.278-6.372-1.34-2.896-4.98 1.548-3.447-9.466 3.258-5.403-6.518-6.948-3.64 2.507-3.448-7.53-7.277.968-1.92-9.076-5.937 4.055-.58 5.02h-3.258l.38-4.442 4.573-6.758zM262.02 274.006v1.738l-4.217.968 1.15 1.927 4.788 1.927 5.37.58 3.83 2.705 3.83-2.127-2.682-2.705h3.45l2.108-2.316 5.178-.77v-1.158l-2.878-1.928.38-2.127 8.047 1.35 11.886-4.634-4.41-1.348 1.15-1.547h9.196l1.53-1.546-18.592-6.57-4.41-1.546-4.79 3.476-5.367-4.443-2.878-.19-.58 3.676-3.638-3.285-4.218 1.35.77 2.126 6.327 1.35-.38 3.086 3.45 2.125 8.438-2.125.19 2.896-6.898 3.285-4.218-3.285-3.83.39 3.83 5.41-1.92.97-2.877-2.51-2.11 1.35 1.92 3.665h3.26l-.77 3.475-2.68-.39-3.45-3.673-2.284.4zM244.94 327.16l-3.656 4.598-.225 5.065 3.197-1.84h3.88l2.74 2.532 2.516-2.076-8.452-8.28zM289.466 386.977l-9.136 8.748.916 2.074 11.186 4.14 1.6-2.758-.917-4.6-3.657.46-2.057-2.3 3.424-3.45-1.358-2.315z M151.767 281.182l1.72 2.602.864 3.475 4.306 1.08 3.017-3.25 2.585 1.306 7.32.647 5.17-2.17.864 7.157h3.017v-3.034l3.016.216 7.538 8.895 4.953 3.035-2.584 4.123 1.08 1.08 9.674 1.954.216 4.34 2.585.432.648-6.51 4.09-1.08 3.016 4.556 6.457 3.034 3.232.647 2.152-2.603.216-4.124 3.873-2.387 1.288 3.476-3.448 6.077.432 3.032L231 314.16l3.874-3.476.216-4.556-2.152-3.476.648-2.817 5.17-2.603 2.368 1.738.432 15.188 3.657-3.25 2.152 1.305-3.017 5.204 3.873.865 5.603-8.68 4.737 4.987-1.936 8.894-4.737 2.603-4.52-2.17-8.178 1.737.863 2.818-2.152 3.476-6.672 1.52-7.538 5.86-6.673 8.897-.864 2.817 4.52 1.737 1.72 4.338 6.242 6.293 9.906 4.34-2.15 9.975-.217 2.818 2.585 1.736 3.45-4.556.43-8.68 5.386-.215 2.584-4.99.433-7.588 6.89-13.45 8.61 3.034 4.52 6.293-1.937 6.29 3.45 1.955 8.393-5.646 2.368 15.403 7.754 9.327.216 4.77-8.61 2.17-4.087 4.34-8.61-1.954-4.304-.217-7.538 5.86 4.52-1.082 5.602-1.08 1.08 1.305-1.503 4.77.216 4.34 2.585 1.737 2.584-.648 1.295-1.953h1.72l-2.8 5.204-5.386.215-2.37 3.475h-3.016l-.864-2.603 4.305-4.338-5.17 1.737-.232-7.373-1.487-.863-4.52 1.953-.433 3.69h-10.338l-8.832 6.08-11.842 3.91-1.287-1.74 5.964-8.9-3.388-3.262-2.153-4.132-4.383-3.346-4.702-.39-8.428-5.903-61.122-10.043-1.01-4.14-5.603-5.205v-4.34l.864-3.906-.433-2.17-2.15-2.17-.433-3.475 5.602-3.908-3.45-18.653-4.737-.217-4.305-5.645 23.65-40.18z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Democratic Republic of the Congo" } }, [
              _c("title", [_vm._v("Democratic Republic of the Congo")]),
              _c("path", {
                attrs: {
                  id: "missing-country-in-the-database",
                  d:
                    "M438.023 546.597l8.912-.155 1.808 2.567-.07 1.892.666.605h4.425l1.27-2.5h1.81l.733.743 2.48-.07.734 8.715 4.287.14v.674l11.52 5.194.536 1.012h2.41l-.267-3.648-4.357-2.092.27-2.766 1.875-4.392 4.287-.14-3.683-12.223.068-5.195 5.826-9.11.068-1.278-.874-.477.035-2.472-1.062-.095-1.072-1.366-17.59-.795-3.225 3.138-5.28-3.475-1.858 1.14-1.348 11.35-3.338 2.576-1.003 2.283.178 3.38-6.017 4.918-1.6-.726.217.94-1.774 1.705z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Central African Republic" } }, [
              _c("title", [_vm._v("Central African Republic")]),
              _c("path", {
                attrs: {
                  id: "41",
                  d:
                    "M443.452 519.23l4.028 4.355 1.59-2.057 2.532.104.544-2.006 2.49-1.556 5.17 3.562 2.98-2.956 11.575.51-10.735-11.082 1.443-.897.198-1.954-2.438-1.15h-3.58l-5.766 5.716-.197 2.35-4.573-.146-.146 1.003-2.982-.305-2.688 5.108.556 1.4z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Congo" } }, [
              _c("title", [_vm._v("Congo")]),
              _c("path", {
                attrs: {
                  id: "missing-country-in-the-database-1",
                  d:
                    "M439.424 526.55l-.052 1.256 4.13.104.147 10.728-3.778-.104-2.187-1.703-1.693.952-.078.476.873.423.25 2.205-2.333 2.006.5 1.058 2.586-2.006h1.244l.396 1.2 1.644.7 5.27-4.46-.103-3.26 1.1-2.652 3.38-2.507.907-8.48-2.402.01-2.783 3.812-7.018.246z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Switzerland" } }, [
              _c("title", [_vm._v("Switzerland")]),
              _c("path", {
                attrs: {
                  id: "224",
                  d:
                    "M423.787 402.82l-3.77 4.01.077.406 1.547-.483 1.394 1.937 2.352-.83 1.625 1.263.668-.38 2.005-3.146-.51-.484-1.98-.05-.96-1.964-2.446-.28z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Cote d'Ivoire" } }, [
              _c("title", [_vm._v("Cote d'Ivoire")]),
              _c("path", {
                attrs: {
                  id: "113",
                  d:
                    "M388.484 521.562l3.697-2.617 4.6-.806 4.694 1.012-2.395-3.622-.702-2.213.7-6.544-4.19.198-1.9-1.813-3.995.104-1.9.305.197 4.425-1.002.406-1.203 2.215 3.095 3.62.304 5.332z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Chile" } }, [
              _c("title", [_vm._v("Chile")]),
              _c("path", {
                attrs: {
                  id: "44",
                  d:
                    "M261.39 683.51l-3.69 8.11 6.37.673.113-5.403-2.792-3.38zM260.137 682.24l-2.775 3.067-.337 3.604-5.368-3.042-5.705-8.22-1.677-2.933 2.35-3.043-.224-3.83-2.68-1.124-2.125-1.572.45-2.144 2.79-.787.563-12.387-4.356-2.48-2.844-64.477.735-1.277 5.567 12.836 1.78.034.58 2.05-2.37 2.867-2.722 15.45 3.873 11.894-1.79 9.007 6.31 26.486.667 15.49 4.52 5.23 4.79-.697zM241.717 649.833l-1.115 1.686.562 2.93 1.115.113.56-3.718-1.123-1.012z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Cameroon" } }, [
              _c("title", [_vm._v("Cameroon")]),
              _c("path", {
                attrs: {
                  id: "37",
                  d:
                    "M428.03 519.428l2.784 2.56-.2 3.96 15.267-.354 1.246-1.4-4.375-4.71-.647-1.703 2.784-5.21-1.893-3.46-1.59-.854V506.5l1.84-1.2.104-5.464-1.46-.164-.024 2.87-6.414 11.972-3.925.2-2.688 1.85-.806 2.864z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "China" } }, [
              _c("title", [_vm._v("China")]),
              _c("path", {
                attrs: {
                  id: "45",
                  d:
                    "M671.802 472.655l-2.064.58-1.487 1.832 1.237 2.41 1.814.164 2.067-1.83.492-2.412-2.058-.743z M594.498 386.128l-2.99 7.52-4.124-.216-4.35 9.518 3.692 4.7-7.606 10.505-3.907-.658-2.61 3.285.647 1.97 3.043.218 1.52 3.5 3.045.658 9.344 12.04v6.13l4.563 2.843 4.996-.872 6.304 3.72 7.605 2.186 3.69-.44 4.132-.44 8.687-5.688 2.827.44 1.08 2.567 2.396.718 3.26 4.814-2.17 4.814 1.306 3.285 3.69 1.312.646 3.942 4.35.44.647-1.972 6.302-3.285 3.907.217 4.563 5.03 3.043-1.312 1.954.216.873 2.413 1.52.216 2.17-3.06 8.688-3.286 7.823-9.413 2.61-8.973-.217-5.912-3.26-.656 1.953-2.19-.434-3.5-8.256-8.314V421l2.386-3.063 2.388-1.098.216-2.413h-6.085l-1.09 3.285-2.828-.656-3.475-3.718 2.17-5.688 3.043-3.285 2.827.217-.434 5.03 1.52 1.314 3.692-3.717 1.306-.217-.432-2.844 3.476-4.16 2.61.217 1.52-4.813 1.782-.942.182-3-1.73-1.815-.146-4.736 3.33-.216-.217-12.214-2.334 1.4-.863 3.13-3.897-.01-11.298-6.353-8.16-9.837-8.28-.086-2.108 1.833 2.68 6.137-.935 5.758-3.336 1.383-1.876-.147-.14 5.696 1.955.44 3.476-1.53 4.562 2.188v2.188l-3.26.216-2.61 5.688-2.387.215-8.472 11.16-8.902 3.94-6.085.44-4.124-2.843-5.868 3.068-6.302-1.97-1.52-4.16-10.643-.656-5.646-9.19h-2.385l-1.92-4.26-2.287-.182z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Colombia" } }, [
              _c("title", [_vm._v("Colombia")]),
              _c("path", {
                attrs: {
                  id: "49",
                  d:
                    "M234.326 498.25l-1.78-.18-11.774 9.706-1.245 3.414-1.608.182.716 7.546-4.105 10.07 4.46 3.776 5.715.363 3.924 5.757 5.704.183-.182 4.312h2.135l2.316-7.91-2.144-2.694.535-5.03 4.46-.364-.536-11.688-9.994-3.232-2.316-6.293 5.716-7.92z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Costa Rica" } }, [
              _c("title", [_vm._v("Costa Rica")]),
              _c("path", {
                attrs: {
                  id: "55",
                  d:
                    "M202.905 502.745l1.202 2.352.977 1.297-1.314 3.898-2.507-1.764-4.097-3.752v-2.48l5.74.45z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Cuba" } }, [
              _c("title", [_vm._v("Cuba")]),
              _c("path", {
                attrs: {
                  id: "57",
                  d:
                    "M205.904 469.846v1.1l4.6.086 2.168-1.263.337.925 4.51 1.098 4.012 3.622-.917 1.262.165 1.436 3.345.84 3.345-1.515 1.504-1.513-2.17-1.098-11.193-6.57-3.923-.423-5.783 2.012z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Cape Verde" } }, [
              _c("title", [_vm._v("Cape Verde")]),
              _c("path", {
                attrs: {
                  id: "39",
                  d:
                    "M350.01 490.264l-1.642.942 1.175.94 1.41-.707-.943-1.176zM354.046 492.165l-1.07.95.76 1.41 1.833-.82-1.524-1.54zM351.704 494.836l-1.375.82 1.478 1.98 1.168-.612-1.272-2.188z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Cyprus" } }, [
              _c("title", [_vm._v("Cyprus")]),
              _c("path", {
                attrs: {
                  id: "58",
                  d:
                    "M484.555 437.794l1.062.77-3.294 3.12-1.573-.052-1.167-.82.156-1.53 2.385-.155 2.43-1.333z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Czech Republic" } }, [
              _c("title", [_vm._v("Czech Republic")]),
              _c("path", {
                attrs: {
                  id: "60",
                  d:
                    "M437.202 398.92h3.829l2.05 1.462 3.794-3.155-3.683-2.627-3.648-1.765-2.498.45-3.39 2.178 3.545 3.458z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Germany" } }, [
              _c("title", [_vm._v("Germany")]),
              _c("path", {
                attrs: {
                  id: "87",
                  d:
                    "M422.257 384.234l3.086-.5v-2.178l2.584-.425 1.418 1.428 1.495.164 2.334-1.012 2.083.588 1.832 1.592.25 5.955 1.832 2.438-2.41.337-4.004 2.515.338.84 3.58 3.353-.252 1.677-3.328 1.677-3.085.086-.752 1.59h-1.58l-.753-1.676-2.75-.675-.087-2.767-1.39-.77.114-1.86-.406-1.33-1.982-1.823.414-2.854 2.16-1.01-.74-5.36z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Denmark" } }, [
              _c("title", [_vm._v("Denmark")]),
              _c("path", {
                attrs: {
                  id: "62",
                  d:
                    "M427.123 370.076l-3.586 3.968-.13 2.584 1.635 4.263 2.56-.483-.32-3.483 1.764-1.97-.034-1.55-1.245-3.222-.644-.106zM428.98 377.354l-1.063.23v1.582l1.128.875.997-.25-.243-1.502-.82-.934zM432.306 375.848l-.95.23-1.055.968.45 1.954 1.29.507-1.333.535-.255.685h2.005l.602-1.1-.77-.377.25-.962.917-1.205-.25-1.042-.9-.192z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Djibouti" } }, [
              _c("title", [_vm._v("Djibouti")]),
              _c("path", {
                attrs: {
                  id: "81",
                  d:
                    "M508.99 499.77l-.492 2.904 3.424-.052.052-4.27-1.253-.77-1.73 2.19z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Dominica" } }, [
              _c("title", [_vm._v("Dominica")]),
              _c("path", {
                attrs: {
                  id: "63",
                  d: "M256.23 485.37l-.76 1.617.916 1.228 1.14-.994-1.296-1.85z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Dominican Republic" } }, [
              _c("title", [_vm._v("Dominican Republic")]),
              _c("path", {
                attrs: {
                  id: "64",
                  d:
                    "M242.434 481.533l-4.573-2.99-2.886-1.022-.578 5.522.578-.047.76 1.46.995-1.15 2.895-.77 2.516.537.294-1.54z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Algeria" } }, [
              _c("title", [_vm._v("Algeria")]),
              _c("path", {
                attrs: {
                  id: "4",
                  d:
                    "M424.625 435.764l-3.526-1.186-14.678 2.758-3.198 2.43 1.953 10.087-5.835.233-3.51 5.646-8.358 2.005.025 4.105 27.53 21.048 4.693.398 15.654-12.23-1.565-1.972-2.938-.398-1.764-2.955V453.5l-1.177-1.184.2-3.155-3.13-3.154-.39-3.354 1.366-.986-.59-3.553-.765-2.35z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Ecuador" } }, [
              _c("title", [_vm._v("Ecuador")]),
              _c("path", {
                attrs: {
                  id: "65",
                  d:
                    "M183.533 531.443l-.536 2.378-.994 1.003.683 1.228 1.754-.69.838-1.46-.536-1.537-1.21-.92z M213.986 529.43l-4.088 2.54-.294 3.772-.82 1.234 2.575 2.473-1.116 1.218.26 3.113 4.606 1.1 6.976-8.257-.017-2.878-3.346-.216-4.738-4.1z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Estonia" } }, [
              _c("title", [_vm._v("Estonia")]),
              _c("path", {
                attrs: {
                  id: "70",
                  d:
                    "M452.236 364.042l-1.308.44 1.308.226.595.69.712-.852-.71-1.215-.596.712zM452.792 365.792l-1.862.833-.643 1.11.643.723 2.362-.875 1.137-.752-1.638-1.038z M462.562 363.3l-4.84-.174-3.068 1.875-.043 1.393 1.988 1.875 6.182 1.047-.218-6.016z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Egypt" } }, [
              _c("title", [_vm._v("Egypt")]),
              _c("path", {
                attrs: {
                  id: "242",
                  d:
                    "M466.16 449.222l2.308.062 4.495 1.244 2.135.06 2.646-2.212h1.234l2.25 1.245h2.844l.51-.034 1.798 5.17.51 1.668.477 2.498-.85.622-1.46-.734-1.687-5.498-1.52-.11-.112 1.866 1.012 3.232 8.1 10.027.173 4.305-2.36 2.723-22.162-.25-.34-25.883z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Eritrea" } }, [
              _c("title", [_vm._v("Eritrea")]),
              _c("path", {
                attrs: {
                  id: "69",
                  d:
                    "M496.224 493.86l-.216-5.094 3.423-3.992.927.71 1.686 5.636 8.09 6.023-1.47 1.808-5.92-5.09h-6.52z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Spain" } }, [
              _c("title", [_vm._v("Spain")]),
              _c("path", {
                attrs: {
                  id: "216",
                  d:
                    "M374.265 458.444l-1.513.873.7.71.813-1.583zM369.01 458.608l-1.876.476.935 1.418h1.406l-.467-1.894zM364.55 457.19l-1.177 1.185 1.643 1.418.935-2.126-1.4-.476zM413.578 426.877l-1.375.467.304 1.235h1.988l.84-.926-1.757-.777z M402.565 416.322H391.55l-2.22-1.004-1.072.078-1.297 2.696.46 2.775 4.21.39.535 1.77-1.833 10.33.078 1.85 2.98 1.618 3.44.232 6.88-1.694 3.364-4.233.077-4.313 5.966-5.395.302-2.386-5.428-.078-5.425-2.636z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Ethiopia" } }, [
              _c("title", [_vm._v("Ethiopia")]),
              _c("path", {
                attrs: {
                  id: "68",
                  d:
                    "M489.982 508.606l6.292-14.005 6.25.036 5.54 4.814-.39 3.968h4.297l.44 2.386 6.95 4.157 4.287.218-8.15 8.756-11.194 3.45h-2.773l-4.944-4.22-1.953-.82-3.786-5.576-2.5.035-.293-2.56 1.928-.637z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Finland" } }, [
              _c("title", [_vm._v("Finland")]),
              _c("path", {
                attrs: {
                  id: "75",
                  d:
                    "M453.072 340.202l1.79.786 1.104 2.074-1.104 1.436-5.55 6.068-.952 3.2 1.27 4.632 4.28 3.2 5.705-2.716 4.598-.64 4.28-6.872-3.174-7.512-3.02-7.192.478-4.633-1.9-.32-.493-3.38-2.56-4.175-2.835 1.962-1.114 4.556-3.008-1.807-4.185-1.022-.934 1.09 1.606 1.453 2.93-.052 2.36 3.812.426 6.052z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Falkland Islands (Malvinas)" } }, [
              _c("title", [_vm._v("Falkland Islands (Malvinas)")]),
              _c("path", {
                attrs: {
                  id: "72",
                  d:
                    "M281.194 678.393l-2.273-.25-2.264 1.52 1.642 1.782 2.896-3.052zM283.46 677.252l-.753 2.41-2.144 1.902.13.63 3.655-1.4 1.513-1.9-2.4-1.642z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "France" } }, [
              _c("title", [_vm._v("France")]),
              _c("path", {
                attrs: {
                  id: "77",
                  d:
                    "M516.857 562.666l.656 1.46h1.055l.526-1.856-2.237.396zM258.823 489.822l-.917.847.683 1.382 1.295-.38-1.062-1.85zM428.04 418.016l-1.688 1.695-.154 1.54 1.374.846.536-.076.303-2.24-.37-1.764zM254.095 484.065l-1.296.535.457 1.15 1.52-.995-.302-.31-.38-.38z M412.973 393.588l-1.91.467-3.82 4.158-1.15.078-1.53-1.08-.992.233-.76 2.386-5.585.154.156 1.236 3.82 2.543 4.436 3.543-.077 4.236-2.37 4.157 5.127 2.463 5.204.154 1.607-1.85 3.286.078.916.848 3.284-.233 1.686-2.162-2.145-2.54-.155-1.617.458-1.77-1.07-1.54-1.834.536-.232-1.383 4.054-4.47v-2.696l-2.348-.767-1.432-.987-6.623-4.175z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "French Guiana" } }, [
              _c("title", [_vm._v("French Guiana")]),
              _c("path", {
                attrs: {
                  id: "78",
                  d:
                    "M276.163 517.285l5.058 3.154-2.645 5.254-.96 1.21-2.808-1.615.08-5.664 1.276-2.34z M540.023 586.93l-1.972.13-.128 1.72 1.313.27 1.972-.925-1.184-1.195z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Gabon" } }, [
              _c("title", [_vm._v("Gabon")]),
              _c("path", {
                attrs: {
                  id: "82",
                  d:
                    "M435.438 526.646l-.104 2.15-4.875-.103-2.983 5.766 7.012 7.666 1.735-1.453-.052-1.503-1.192-.554v-1.057l2.69-1.702 2.386 1.807 2.638.052-.054-9.067-4.176-.196-.052-1.903-2.974.096z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "UK & Ireland" } }, [
              _c("title", [_vm._v("UK & Ireland")]),
              _c("path", {
                attrs: {
                  id: "243",
                  d:
                    "M393.974 378.693l-2.853.32-.155 2.56 1.9 1.278 2.06-.474.795-1.436-1.746-2.247z M400.63 367.984l-1.583 2.395.63.958h3.65v1.6l-.953 1.278.632 3.354 2.058 3.994 1.58 3.672 2.534.96 1.105 1.92-.155 1.754-1.582.96-.156.794 1.106.64-.95 1.28-2.222.958-4.28-.477-6.663 3.035-2.22-1.115 6.345-3.674-.796-.476-3.33-.32 2.06-3.033.318-2.56 2.696-.318-.475-4.953-3.175-.156-.95-1.115.155-3.675-1.9.156 1.9-6.387 3.492-2.56 1.127 1.11z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Georgia" } }, [
              _c("title", [_vm._v("Georgia")]),
              _c("path", {
                attrs: {
                  id: "83",
                  d:
                    "M495.144 415.596l2.827 3.69 3.528 1.626 2.17-.01 3.725-1.01.935-1.46-11.02-4.124-2.164 1.288z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Ghana" } }, [
              _c("title", [_vm._v("Ghana")]),
              _c("path", {
                attrs: {
                  id: "88",
                  d:
                    "M399.09 513.18l.97 2.272 2.523 3.96 1.4-.053 3.82-2.172-.27-12.354-2.956-.864-4.14.112-1.346 9.097z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Greenland" } }, [
              _c("title", [_vm._v("Greenland")]),
              _c("path", {
                attrs: {
                  id: "92",
                  d:
                    "M311.396 319.066l1.41 2.12-.71 2.583h-1.408l-1.885-2.12.467-1.643 2.126-.94zM370.16 313.19l3.992 1.175-.234 3.293-4.227-2.118-.94-1.176 1.41-1.175z M292.587 282.398l-1.176 1.877 2.12 2.117-.943 2.118 3.06 3.994 3.76-1.176 4.937-.466 5.644 6.11 3.76 10.105-3.05 6.345 4.227-.708 2.354 1.41.23 3.06-5.167.232 2.818 2.817 3.527.71-7.754 10.338-.942 6.346 1.644 5.17-1.176 3.06 2.118 6.577 3.993 4.47 1.175-.233 2.584-.71.232 3.76 1.642 2.353 3.052-.234 2.353-8.696 7.052-8.697 10.58-4.227 6.58-8.23 3.05 1.41h6.344l5.17-5.17 6.346-2.583.708-3.994-3.993-3.527-3.526-1.175-1.884-4.936 4.47-2.584 7.053 3.76 2.352-2.584-3.76-2.117 7.995-10.814-1.41-4.702-3.76-.232 1.408-4.228 4.703-2.118 9.637-8.46-2.816-3.054-10.815.94-5.645 5.647 3.295-7.288-3.762-.942-2.117 3.76-3.05-2.584-8.465.94 2.354-3.76 13.865-.466-3.528-4.702-15.04-2.817-6.11.942.233 3.06-6.345-2.117.232-2.118-4.47.94-.942 2.354 4.703 1.643-4.936 3.527-3.527-3.994-4.936-1.408-.71 3.76h-4.936l-1.885-3.994-7.754-1.176-4.23 2.117-.232 2.818-5.402-.71-3.294 1.41.234 3.293v1.644l-6.11 1.176-2.82-1.877-1.884 3.05 2.82 3.06 5.877-.708.466 1.885-4.47 2.118-3.99-1.907z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Gambia" } }, [
              _c("title", [_vm._v("Gambia")]),
              _c("path", {
                attrs: {
                  id: "85",
                  d:
                    "M366.72 497.006l-.112.96 5.98-.087.304-.892-.13-.898-1.72.7-4.323.216z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Guinea" } }, [
              _c("title", [_vm._v("Guinea")]),
              _c("path", {
                attrs: {
                  id: "97",
                  d:
                    "M369.77 505.304l2.63 4.046 3.422-2.974 3.51-.155 2.923 3.882 2.48 1.635.933-1.816.83-.465-.06-3.993-1.65-4.737-5.066.562-6.267-.5-.034 1.605-3.65 2.912z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Equatorial Guinea" } }, [
              _c("title", [_vm._v("Equatorial Guinea")]),
              _c("path", {
                attrs: {
                  id: "67",
                  d:
                    "M427.184 522.134l-.396 1.703 1.19.648 1.144-.855-.397-1.755-1.54.26zM430.77 526.697l-.053 1.202 3.924.197-.05-1.356-3.82-.043z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Greece" } }, [
              _c("title", [_vm._v("Greece")]),
              _c("path", {
                attrs: {
                  id: "91",
                  d:
                    "M461.69 438.442l1.408.043.59.873h2.05l1.362-.5.46.552-.908 1.192-4.002.14-.728-.96-.77-.458.538-.882z M453.004 427.213l-.096 1.15 4.003 2.014 1.912.734-1.003 1.056-2.23.227-.32 1.01.77 1.738 2.5 1.33 1.09.097.137-2.98 1.635-1.973-4.46-5.272.59-1.79 1.045-.042 1.59 1.28 1.003-.502.32-1.79 3.73.534 1.135-3.24-1.953 1.376-5.73-.14-3.727 1.93-1.94 3.255z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Guatemala" } }, [
              _c("title", [_vm._v("Guatemala")]),
              _c("path", {
                attrs: {
                  id: "96",
                  d:
                    "M183.456 491.11l5.126 3.752 5.17-6.423-.882-1.332-1.764-.062v-3.76l-1.322-.805-4.002 1.193 1.53 3.526-3.856 3.91z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Guinea-Bissau" } }, [
              _c("title", [_vm._v("Guinea-Bissau")]),
              _c("path", {
                attrs: {
                  id: "185",
                  d:
                    "M368.196 502.356l1.21 2.395 3.397-2.92.035-.9-4.003-.58-.64 2.006z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Guyana" } }, [
              _c("title", [_vm._v("Guyana")]),
              _c("path", {
                attrs: {
                  id: "98",
                  d:
                    "M261.4 510.654l6.24 5.652-2.48 2.87-.2 1.703 3.26 3.36-.08 3.233-5.67 2.16-3.396-4.59.726-5.515-1.452-4.105 3.05-4.77z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Honduras" } }, [
              _c("title", [_vm._v("Honduras")]),
              _c("path", {
                attrs: {
                  id: "102",
                  d:
                    "M194.408 488.742l7.987-.303 2.37 2.816-1.48-.338-2.843.12-3.717 3.493-1.59 3.537-1.046-.555-.01-3.872-2.3-1.54 2.628-3.358z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Croatia" } }, [
              _c("title", [_vm._v("Croatia")]),
              _c("path", {
                attrs: {
                  id: "56",
                  d:
                    "M443.417 407.816l-3.05 2.515h-3.096l-.37 2.18 1.417.37.71-1.054 1.113.977.89 3.112 6.11 2.853.605-.69-6.197-6.397.63-1.165 5.89-.226.595-1.877-3.838.11-1.408-.707z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Haiti" } }, [
              _c("title", [_vm._v("Haiti")]),
              _c("path", {
                attrs: {
                  id: "99",
                  d:
                    "M231.845 477.16l2.974.31-.355 3.648-.294 1.92-3.465-.19-.614.925-1.062-.077-.38-1.997 3.656-.305-.225-2.073-1.678-.69 1.443-1.473z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Hungary" } }, [
              _c("title", [_vm._v("Hungary")]),
              _c("path", {
                attrs: {
                  id: "104",
                  d:
                    "M444.386 403.01l-1.003 1.573.078 2.403 1.6.82 4.92.147 6.853-5.774.034-1.28-.742-.37-4.953 2.247-6.786.233z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Indonesia" } }, [
              _c("title", [_vm._v("Indonesia")]),
              _c("path", {
                attrs: {
                  id: "107",
                  d:
                    "M639.517 513.628l-.24 1.97 5.868 9.863h1.71l12.23 20.462 4.895.492 2.445-7.148-3.916-2.464-.735-3.94-22.258-19.234zM697.475 540.89l1.954 2.397-1.272 3.596v.684h2.887l1.02-8.99.935.26 1.694 8.213 1.615.434 1.53-3.512-1.53-5.308-1.272-2.31 3.993-2.91-.934-1.29-3.82 2.48h-1.02l-1.866-2.74.597-1.2 3.146-1.54 4.754 1.454 1.444-.09 3.57-3.334-1.443-1.45-3.312 2.564h-2.127l-3.224-1.538-2.29.086-2.55 4.106-1.616 7.105-.863 2.834zM718.79 524.805l-1.615 3.935 2.55 3.337h.848l1.105-2.223.597-.77-1.105-1.2-1.617-.598-.762-2.48zM723.805 537.73l-3.482.77-1.02 1.114.846 1.453 2.29-.855 1.442-.855 2.126 1.712.935-.772-1.693-2.057-1.445-.51zM666.045 548.854l-2.377 1.625.51 1.363 7.564 1.712 3.82.684 1.615 1.71 4.33.346 2.04 1.71 1.868-.43 1.702-1.54-3.146-1.452-2.714-2.308-7.053-1.713-8.158-1.71zM690.768 556.295l-1.865 1.03 1.104 1.2 2.715-1.027-1.954-1.203zM693.99 555.526l.34 1.625 1.953.51.76-.94-.847-1.29-2.205.096zM698.668 559.805l-2.377.347 2.127 1.798h1.694l-1.442-2.145zM699.342 556.98l-.51 1.026 3.82.596 2.974-1.71-1.694-.512-2.715.77-1.02-.855-.855.684zM711.833 557.583l-4.416 3.683.423.942 1.866-.345 2.205-2.06 4.332-.596-.848-1.452-3.56-.172zM734.126 532.446l-3.604.406-2.315 1.693.96 1.938 3.924.726v.726l-2.48 2.015 1.202 4.193 1.2.078 1.038-4.114h1.92l.805 4.027 9.36 7.746.242 6.05 3.198 3.467 1.442-.077.32-21.37-5.44-3.784-5.124 3.467-1.843 1.132-3.043-1.937-.078-6.128-1.684-.254zM690.69 519.532l-1.998 7.503-10.83 3.656-3.242-3.803-1.573.433 2.94 11.34 4.397.493 5.87 2.222v2.222l2.687-.493 3.917-5.42v-4.435l2.204-4.436 2.446.49-2.938-6.162-.45-3.968-3.43.358z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Ireland" } }, [
              _c("title", [_vm._v("Ireland")]),
              _c("path", {
                attrs: {
                  id: "110",
                  d:
                    "M394.915 383.085l-.786 5.187-6.976 2.56h-2.223l-1.58-1.115v-.96l3.49-2.238-.95-1.92.156-2.715 3.018.155 1.383-3.25-.183 2.887 2.344 1.858 2.307-.45z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Israel" } }, [
              _c("title", [_vm._v("Israel")]),
              _c("path", {
                attrs: {
                  id: "111",
                  d:
                    "M486.378 444.9l-1.365 4.347 1.77 5.213 2.032-7.616v-1.633l-2.437-.31z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "India" } }, [
              _c("title", [_vm._v("India")]),
              _c("path", {
                attrs: {
                  id: "106",
                  d:
                    "M595 509.688l3.958-1.938 2.352-8.505-.104-10.44 13.468-14.54v-3.448l2.774-1.08-.104-3.985-2.99-5.817 1.71-3.12 3.743 3.448 4.808.216v1.937l-1.495 1.616.318.863 2.567.104.536 2.904h.753l1.928-3.45.96-9.04 3.206-2.266.104-3.12-1.28-2.48-2.03-.105-7.95 5.256.5 3.38-5.585-.02-1.97-2.41-1.072.138.363 3.354-12.075-.863-7.484-3.338-.397-4.106-4.99-3.094-.06-6.37-3.422-3.917-7.867.752.856 3.424 3.854 3.12-6.665 13.642-4.46.337-.734 1.643 4.393 4.062-.216 4.105-4.486-.07-.483 2.04 3.727-.163.104 1.616-2.67 1.4 1.71 3.232 3.312 1.08 2.03-1.504.96-2.687 1.177-.535 1.392 1.398-.425 3.45-.96 1.616.217 2.8L595 509.688z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Iraq" } }, [
              _c("title", [_vm._v("Iraq")]),
              _c("path", {
                attrs: {
                  id: "109",
                  d:
                    "M502.793 433.637l-1.348 6.664-5.585 4.65.354 2.196 5.455.37 8.687 7.07 4.857-.137.13-1.635 1.78-1.91 2.49 1.41.33-.313-4.816-6.405-2.282-.14-3.033-3.897.604-2.868.926-.12.32-1.272-4.133-4.348-4.737.685z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Iran" } }, [
              _c("title", [_vm._v("Iran")]),
              _c("path", {
                attrs: {
                  id: "108",
                  d:
                    "M507.41 427.516l-1.058 1.098.104 1.738 1.314 1.842 4.658 5.1-.71 2.04h-.81l-.407 2.04 2.638 3.372 2.43.207 4.865 6.732 2.732.208 2.126 1.53.105 3.06 8.41 4.9h3.14l1.927-1.633 2.43-.104 1.418 3.268 9.085 1.262.27-3.337 3.007-1.09.14-1.193-2.396-3.268-5.334-4.288 2.8-2.55-.197-1.124-3.51-.544-1.487-11.843-.173-2.722-9.518-3.64-4.218.95-2.36 2.896-2.093-.14-.604.512-4.66-.303-5.878-4.288-2.188-2.394-1.003.24-1.808 2.067-3.187-.6z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Iceland" } }, [
              _c("title", [_vm._v("Iceland")]),
              _c("path", {
                attrs: {
                  id: "105",
                  d:
                    "M366.26 340.52l-1.692-.958-2.283 1.443-1.962 1.814.052 1.012 2.54.32-.155 1.814-.898.908.217.588 2.54.164v2.938l3.656.64 2.17 1.23 2.437.104 4.186-2.083 3.23-4.27.053-2.888-1.963-1.66-1.642-1.392-.743.536-1.115 1.444-1.27-.164-1.272-1.393-1.642.156-2.386 1.98-1.437 1.546-.795-.69-.053-1.713.795-.536-.57-.89z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Italy" } }, [
              _c("title", [_vm._v("Italy")]),
              _c("path", {
                attrs: {
                  id: "112",
                  d:
                    "M440.668 431.898l-1.253-.674-4.278.674.146 1.158 3.847 1.937.58.63 1.01.148-.052-3.872zM427.806 423.566l-2.29 1.158.304 4.47 1.833.31 1.374-1.312v-4.235l-1.22-.39z M423.233 409.39l-.535 1.357.146 1.478 2.065 2.412 3.25-.113 7.174 8.334 4.48 1.297 2.645 2.498.63 5.695 1.417-.828 1.23-3.104-.304-2.23 2.1-.19.305-1.262-5.922-2.834-5.62-5.523-2.237-3.303-.546-3.137 2.86-.684-.733-2.066-1.754-1.478-1.513-.07-2.108.58-1.99 2.78-1.2.796-1.86-1.14-1.982.735z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Jamaica" } }, [
              _c("title", [_vm._v("Jamaica")]),
              _c("path", {
                attrs: {
                  id: "114",
                  d:
                    "M221.533 480.798l-3.008.76v.84l1.755 1.012h1.84l1.168-1.35-1.755-1.262z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Jordan" } }, [
              _c("title", [_vm._v("Jordan")]),
              _c("path", {
                attrs: {
                  id: "118",
                  d:
                    "M489.473 447.25l-2.126 7.417-.096 1.133h3.347l3.743-3.303.094-1.253-1.53-1.564 2.74-2.272-.396-2.11-.752.174-2.282 1.635-2.74.144z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Japan" } }, [
              _c("title", [_vm._v("Japan")]),
              _c("path", {
                attrs: {
                  id: "115",
                  d:
                    "M709.317 426.193l-1.41 1.418.58 1.997 1.235.086.83 4.332.993 1.08 1.738-1.582.15-4.773-2-2.125-2.116-.432zM716.688 422.188l-2.66 2.156-.59 2.72 1.812 1.25 2.625-2.75.37-3.063-1.557-.312zM713.613 418.033l-4.22 4.832v2.322l2.605-.312 4.085-3.592 2.73-.502.664.78.015 2.377.688 1.25h1.255l1.763-2.158.743-2.837 3.553-.086 3.476-4.166-1.815-6.915-.83-3.664 1.815-1.495-4.133-6.24-.944-.745-1.875.744-.48 2.584v2.083l.993 1.168.33 5.498-2.56 3.164-1.486-.917-1.16 2.584-.25 2.412.91 1.417-.58 1.08-1.902-1.582h-1.322l-1.157.666-.91.253zM720.73 380.396l-1.322 1.168.665 2.498 1.158 1.166-.085 3.83-1.487.578-1.158 2.584 3.388 4.66 2.23-.753.415-1.167-2.396-2.16 1.487-1.92 1.572.25 3.43 2.305.37-2.584 1.63-2.978 2.28-2.312-2.468-1.125-.944-1.8-1.236.83-1.07 1.33-2.317-.5-2.395-1.583-1.746-2.316zM733.2 377.812l-2.316 3.25.164 1.582 1.158-.502 2.723-3.414-1.73-.916zM736.26 373.066l-.828 2.248.086 1.496 1.41-.918 1.32-2.662v-.994l-1.987.83z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Kenya" } }, [
              _c("title", [_vm._v("Kenya")]),
              _c("path", {
                attrs: {
                  id: "119",
                  d:
                    "M491.142 521.365l2.3 4.484-2.76 5.782-.36 1.754 13.77 8.516 4.27-6.708-2.16-1.754-.043-8.835 2.704-2.956-4.313 1.434-3.258.044-5.1-4.305-1.608-.692-2.98.277-.526.883.064 2.075z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Kyrgyz Republic" } }, [
              _c("title", [_vm._v("Kyrgyz Republic")]),
              _c("path", {
                attrs: {
                  id: "123",
                  d:
                    "M565.463 411.316l-.268 2.188.216 1.35 7.522 2.523-6.604 2.662-.75-.624-1.428.917.068.5.76.347 4.636.12 2.35-.708 3.02-3.803 3.775.655 4.556-6.31-12.188-1.66-1.686 4.087-2.127-2.28-1.852.034z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Cambodia" } }, [
              _c("title", [_vm._v("Cambodia")]),
              _c("path", {
                attrs: {
                  id: "36",
                  d:
                    "M655.076 497.982l3.535 3.776 6.577-4.875.58-7.692-3.397 2.344-1.764-.985-2.396-.32-1.34-.942-.65.035-1.753 2.878.285 1.333 1.78.994-.215 2.705-1.24.75z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Comoros" } }, [
              _c("title", [_vm._v("Comoros")]),
              _c("path", {
                attrs: {
                  id: "50",
                  d: "M514.36 560.013l.395 1.32 1.71.27.657-1.72-2.763.13z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "North Korea" } }, [
              _c("title", [_vm._v("North Korea")]),
              _c("path", {
                attrs: {
                  id: "missing-country-in-database-2",
                  d:
                    "M687.75 407.047l1.59.666.485 5.566 3.155.182 2.974-3.483-1.03-.917.122-3.734 2.73-3.304-1.39-2.506.907-1.04.5-2.59-1.58-.72-1.35.684-1.67 5.064-2.696-.232-3.12 3.682.374 2.68z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Korea" } }, [
              _c("title", [_vm._v("Korea")]),
              _c("path", {
                attrs: {
                  id: "121",
                  d:
                    "M696.446 410.443l5.342 4.356.91 4.22-.184 2.263-2.61 2.94-2.248.12-2.55-5.507-.97-2.63 1.03-.794-.243-1.1-1.27-.568 2.793-3.3z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Kuwait" } }, [
              _c("title", [_vm._v("Kuwait")]),
              _c("path", {
                attrs: {
                  id: "122",
                  d:
                    "M519.2 452.774l-1.945-1.056-1.35 1.356.147 2.715 3.14 1.2.008-4.216z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Kazakhstan" } }, [
              _c("title", [_vm._v("Kazakhstan")]),
              _c("path", {
                attrs: {
                  id: "116",
                  d:
                    "M513.495 402.163l3.544-1.513 3.958-.14.276 6.052h-2.317l-1.772 2.888 2.317 3.847 3.414 1.928.31 2.205 1.256-.416 1.157-1.375 1.91.415.96 1.928h2.454v-2.473l-1.504-4.4-.684-3.57 4.364-1.928 5.87.96 3.683 3.708 8.323-.82 4.644 6.596 5.455.274 1.504-2.472 1.91-.416.273-2.748 2.862-.14 1.503 1.79 1.505-3.57 12.957 1.79 2.18-2.888-3.684-4.537 4.91-10.72 3.958.275 2.73-6.594-5.454-.553-3.138-3.024-8.644 1.002-11.134-10.762-3.926 3.482-11.902-5.402-14.6 7.148-.406 5.084 3.413 3.985-6.655 3.76-8.636-.19-1.807-2.654-6.77-.373-6.413 4.123-.14 5.638 5.983 4.8z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Lao People's Democratic Republic" } }, [
              _c("title", [_vm._v("Lao People's Democratic Republic")]),
              _c("path", {
                attrs: {
                  id: "124",
                  d:
                    "M650.745 466.397l-2.092 1.062-1.737 5.064 2.904 3.7-.485 4.09.485.195 4.832-2.343 6.482 7.243-.157 4.563 1.41.762 3.482-2.827-.286-2.238-10.053-9.552.096-1.46 1.254-.874-.874-2.438-4.158-.684-1.103-4.265z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Lebanon" } }, [
              _c("title", [_vm._v("Lebanon")]),
              _c("path", {
                attrs: {
                  id: "125",
                  d:
                    "M487.14 440.04l.052 1.687-.708 2.56 2.438.208.156-3.63-1.94-.824z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Saint Lucia" } }, [
              _c("title", [_vm._v("Saint Lucia")]),
              _c("path", {
                attrs: {
                  id: "198",
                  d:
                    "M258.746 493.28l-.614 1.306.994 1.07 1.296-.69-1.676-1.686z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Sri Lanka" } }, [
              _c("title", [_vm._v("Sri Lanka")]),
              _c("path", {
                attrs: {
                  id: "42",
                  d:
                    "M603.264 505.4l.217 2.35.217 1.712-1.27.216.64 3.848 1.908 1.07 2.966-1.71-.846-4.055.216-1.494-2.756-2.56-1.29.623z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Liberia" } }, [
              _c("title", [_vm._v("Liberia")]),
              _c("path", {
                attrs: {
                  id: "128",
                  d:
                    "M378.198 515.027l9.49 6.345-.226-4.805-2.87-3.38-2.8-2.48-3.594 4.32z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Lesotho" } }, [
              _c("title", [_vm._v("Lesotho")]),
              _c("path", {
                attrs: {
                  id: "126",
                  d:
                    "M470.896 606.83l2.637-2.033 1.245.053 1.503 1.875-.154 1.877-2.533.934v.728l-2.792-.156-.673-2.03.77-1.25z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Lithuania" } }, [
              _c("title", [_vm._v("Lithuania")]),
              _c("path", {
                attrs: {
                  id: "131",
                  d:
                    "M452.14 375.236l-2.146.363.173 2.024 3.355.25 1.27 1.042.333 1.81 1.034 1.443 3.068-.13 2.938-3.744-.172-2.222-5.533-.867-4.32.03z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Luxembourg" } }, [
              _c("title", [_vm._v("Luxembourg")]),
              _c("path", {
                attrs: {
                  id: "132",
                  d:
                    "M420.424 397.582l.76.68.88.082.194-1.734-.253-.974-1.224.583-.356 1.362z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Latvia" } }, [
              _c("title", [_vm._v("Latvia")]),
              _c("path", {
                attrs: {
                  id: "127",
                  d:
                    "M462.823 369.964l-6.362-1.037-1.085 2.823-1.833.548-.96-1.173-.96-1.81-1.04.76-.588 3.133v1.708l2.242-.375 4.665.084 5.618 1.044 2.25-.657-.13-2.523-1.815-2.523z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Libyan Arab Jamahiriya" } }, [
              _c("title", [_vm._v("Libyan Arab Jamahiriya")]),
              _c("path", {
                attrs: {
                  id: "129",
                  d:
                    "M429.958 453.518l1.35-.225.397-3.112h.674l2.757-4.527 6.804 1.98 1.857 2.886 6.69 3.06 3.482-1.47-.34-1.47-1.52-1.47.173-1.02 2.473-2.093h4.894l1.856 2.49 3.934.57.51 31.888-2.92-.112-17.652-9.18-1.91 1.08-7.253-1.814-1.97-2.604-2.87-.397-1.46-2.604.043-11.858z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Morocco" } }, [
              _c("title", [_vm._v("Morocco")]),
              _c("path", {
                attrs: {
                  id: "149",
                  d:
                    "M402.505 439.903h-9.982l-1.954 4.34-4.505 2.17-3.72 10.06-7.242 4.342-10.174 16.76 9.982-.198.39-4.927h2.54v-6.708h8.81l.196-8.68 8.42-1.97 3.526-5.724 5.48-.198-1.77-9.267z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Moldova" } }, [
              _c("title", [_vm._v("Moldova")]),
              _c("path", {
                attrs: {
                  id: "146",
                  d:
                    "M465.14 401.376l2.68 4.123-.225 2.333.96.043 2.272-3.847-2.73-3.39-1.548-.64-1.41 1.376z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Montenegro" } }, [
              _c("title", [_vm._v("Montenegro")]),
              _c("path", {
                attrs: {
                  id: "147",
                  d:
                    "M449.68 416.677l-1.266 1.79.362 1.098 1.504.275 1.184-1.607-1.784-1.556z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Madagascar" } }, [
              _c("title", [_vm._v("Madagascar")]),
              _c("path", {
                attrs: {
                  id: "134",
                  d:
                    "M526.988 561.474l-1.842 4.374-3.154 5.566-5.523.396-2.37 2.783.397 8.488-3.423 3.978.396 6.76 2.897 3.312 3.423-.396 3.423-2.524-.787-3.977 7.894-13.657-1.582-1.72 1.582-3.312 1.71.526.527-1.322-1.582-6.76-.924-2.784-1.062.27z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Macedonia" } }, [
              _c("title", [_vm._v("Macedonia")]),
              _c("path", {
                attrs: {
                  id: "241",
                  d:
                    "M456.643 418.924l-2.912.96.14 2.472.683.873 3.458-1.607-1.367-2.7z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Mali" } }, [
              _c("title", [_vm._v("Mali")]),
              _c("path", {
                attrs: {
                  id: "138",
                  d:
                    "M377.584 494.845l2.662-1.823 14.8-.087-3.424-23.806 3.907-.113 18.902 14.428 2.54.362-.958 8.02-11.886 1.08-9.17 6.848-1.67 4.686-6.37.27-1.625-4.677-4.884.346.188-1.53-3.014-4.005z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Myanmar" } }, [
              _c("title", [_vm._v("Myanmar")]),
              _c("path", {
                attrs: {
                  id: "33",
                  d:
                    "M645.533 501.596l-2.396-3.838 1.737-2.438-1.642-3.018-1.548-.294-.294-5.064-2.316-4.486-.675 1.07-1.548 2.63-1.937.293-.968-1.27-.484-3.414-1.453-2.73-5.913-5.576 1.453-.96.27-4.036 2.16-3.63.935-9.033 3.13-2.135.102-3.293 1.877.622 2.956 4.28-2.194 4.7 1.48 3.69 3.654 1.436.666 4.02 4.91.762-1.357 2.343-6.19 2.438-.673 3.993 4.547 5.844.19 3.12-1.063 1.072.095.977 3.39 4.97.095 5.16-.997 1.796z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Mongolia" } }, [
              _c("title", [_vm._v("Mongolia")]),
              _c("path", {
                attrs: {
                  id: "145",
                  d:
                    "M597.438 386.215l5.03-6.673 6.043 2.792 4.106 1.098 5.03-4.615-3.414-2.517 2.248-3.172 6.707 2.37 2.325 3.81 4.2.113 2.195-1.633 4.52-.182.986 1.678 7.512.38 4.754-4.85 6.577.69-.38 6.605 2.88.656 3.534-1.606 3.744 1.85-.088.935-2.714.078-2.827 5.93-2.195.217-8.54 11.16-8.723 3.847-5.455.424-4.53-2.923-5.79 3.095-5.705-1.77-1.617-4.142-10.805-.762-5.532-9.377-2.688-.175-1.387-3.33z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Mauritania" } }, [
              _c("title", [_vm._v("Mauritania")]),
              _c("path", {
                attrs: {
                  id: "141",
                  d:
                    "M364.998 478.266l1.885 2.463-.39 10.65 2.74-1.973 1.953-.397 2.74.985 3.13 4.34 2.938-1.97 14.288-.2-3.526-23.866 3.786-.02-7.054-5.4.01 3.51-8.93.01-.044 6.697-2.567-.01-.328 4.945-10.632.234z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Malta" } }, [
              _c("title", [_vm._v("Malta")]),
              _c("path", {
                attrs: {
                  id: "139",
                  d:
                    "M440.815 438.34l-1.443.293.052 1.6 1.297.433.58-.484-.485-1.843z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Mauritius" } }, [
              _c("title", [_vm._v("Mauritius")]),
              _c("path", {
                attrs: {
                  id: "142",
                  d:
                    "M544.89 584.008l-1.312 1.72.26 1.858 2.767-2.256-1.715-1.322z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Maldives" } }, [
              _c("title", [_vm._v("Maldives")]),
              _c("path", {
                attrs: {
                  id: "137",
                  d:
                    "M582.396 516.386l.26 2.256 1.442.527.26-1.99-1.962-.794zM584.238 521.156l-.13 2.784 1.055.525.925-1.856-1.85-1.454zM584.506 526.595l-.925.925 1.057.925 1.313-.925-1.444-.925z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Malawi" } }, [
              _c("title", [_vm._v("Malawi")]),
              _c("path", {
                attrs: {
                  id: "135",
                  d:
                    "M487.968 567.074l2.69 2.81-.054 3.597.52 1.515 3.57-3.855-.414-4.9-1.912-1.46-1.7-8.602-2.95-.104 1.34 6.196-1.09 4.804z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Mexico" } }, [
              _c("title", [_vm._v("Mexico")]),
              _c("path", {
                attrs: {
                  id: "143",
                  d:
                    "M133.847 433.982l4.175 13.146-1.945 1.09.216 2.61 3.674 2.826v5.23l4.538 4.355-1.945-12.848-2.593-8.497.648-5.877 2.16.217.866 1.962-.864 5.005 11.237 21.99v7.84l9.077 10.667 9.94 4.572 4.106-2.396 5.835 4.79 3.46-3.484-1.514-3.925 4.97-1.52 1.513.872 1.512-1.522h2.377l4.32-7.624-2.16-1.962-8.428 1.962-1.945 5.662-4.97.874-5.835-2.396-2.593-8.27 1.96-10.435-4.01-2.5-1.91-10.02-1.6-.682-2.92 2.965-3.355-1.79-1.313-6.68-13.286-1.394-6.863-5.16-6.536.342z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Malaysia" } }, [
              _c("title", [_vm._v("Malaysia")]),
              _c("path", {
                attrs: {
                  id: "136",
                  d:
                    "M675.527 526.896l2.61 3.018 10.012-3.467 1.978-7.643 4.46-.32 4.08-2.955-5.29-3.855-1.21-2.12-2.61 4.816.958 2.767-1.59 2.31-3-.77-7.27 5.332.188 3.085-3.317-.2z M648.36 511.796l1.735 3.898.39 5.064 2.325 3.604 5.096 3.083 1-.79 1.464-.29-.212-1.91-1.84-4.477-2.698-5.73-.227 1.002-3.25-.146-2.334-3.354-1.45.046z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Mozambique" } }, [
              _c("title", [_vm._v("Mozambique")]),
              _c("path", {
                attrs: {
                  id: "150",
                  d:
                    "M482.79 596.36l2.327 1.927 5.48-3.335.88-4.953v-8.18l8.79-7.19 1.507.053 5.322-5.107-.828-10.53-13.81 1.744.52 3.338 2.02 1.757.57 5.73-4.757 4.643-1.14-2.603.207-3.44-2.74-2.973-6.725 3.13 6.258 3.182.21 9.274-4.142 6.146.053 7.385z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Namibia" } }, [
              _c("title", [_vm._v("Namibia")]),
              _c("path", {
                attrs: {
                  id: "152",
                  d:
                    "M444.22 603.863l2.898.208 1.702 1.72 4.037.053.984-11.462v-7.502l2.586-.52.986-7.867 6.57-.205 2.322-1.927-3.933-.156-5.324.726-5.74-2.082h-16.13l.416 4.58 5.376 7.918-.934 4.062.053 2.136 4.134 10.32z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "New Caledonia" } }, [
              _c("title", [_vm._v("New Caledonia")]),
              _c("path", {
                attrs: {
                  id: "161",
                  d:
                    "M798.706 602.576l-.303 1.547 3.983 5.56 2.145.925.304-2.16-6.128-5.872z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Niger" } }, [
              _c("title", [_vm._v("Niger")]),
              _c("path", {
                attrs: {
                  id: "165",
                  d:
                    "M413.396 500.17l2.204-.053 1.988-2.98 3.336-.598 3.553 2.17 7.58.215 5.86-2.386 2.205-1.895.164-2.49 4.088-4.122 1.08-9.104-2.688-5.637-6.88-1.677-15.923 12.413-2.256-.218-.97 8.617-8.123.812 4.782 6.928z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Nigeria" } }, [
              _c("title", [_vm._v("Nigeria")]),
              _c("path", {
                attrs: {
                  id: "166",
                  d:
                    "M413.984 515.185l3.39.164 4.087 4.556 1.988.544 1.558-.76 2.367-.33.805-3.302 3.225-2.117 3.492-.162 6.396-11.766-.103-2.653-2.955-2.274-5.913 2.603-7.91-.112-3.77-2.386-2.688.596-1.4 2.438-.104 6.88-2.256 3.198-.208 4.88z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Nicaragua" } }, [
              _c("title", [_vm._v("Nicaragua")]),
              _c("path", {
                attrs: {
                  id: "164",
                  d:
                    "M203.216 491.62l1.893.38.06 3.882-2.204 6.293-5.938-.588-1.323-3.034 1.764-3.682 3.344-3.11 2.402-.14z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Netherlands" } }, [
              _c("title", [_vm._v("Netherlands")]),
              _c("path", {
                attrs: {
                  id: "155",
                  d:
                    "M421.35 384.572l-3.916 1.928.83.752.087 1.928-.828-.164-.917-1.426-2.188 3.467 3.363.7 1.253 1.322.666.016.44-2.99 2.116-.89-.907-4.644z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Norway" } }, [
              _c("title", [_vm._v("Norway")]),
              _c("path", {
                attrs: {
                  id: "169",
                  d:
                    "M437.056 285.762l-1.426-1.435-3.164 1.54h-5.81l-.916 3.388 3.26 2.878 1.425-.208 2.04-3.49 1.73 1.234-1.23 2.463-.614 3.596 1.428 2.255 3.06-5.135 3.98-4.832-1.532-1.33-2.23-.926zM438.784 279.6l-2.55 2.36 1.53 2.358h2.748l1.124 1.54 3.363 1.745 3.87-2.256 2.654-2.256-.916-1.85-2.654-1.538-1.938 1.746-1.32-1.644-1.022.104-1.322 2.878-1.936-1.954-.208-1.33-1.424.098zM444.593 290.18l-2.04 1.85-1.73 1.332.813 1.435 1.636.51 2.652-1.235 1.23-1.54-1.125-1.85-1.437-.503z M460.567 327.41l1.747-1.28-.157-1.435-1.106-.64.158-1.755h.95v-.96l-4.123-1.114-6.18.64-.632 2.714-1.428-.477-.95-1.6-3.018.156-.32 3.032-1.426.64-.794-1.6-6.345 5.11 1.272 1.436-2.378 1.115-5.393 10.7-1.9 1.28.155.96 1.9.958-.475 2.075-3.173-.164-.952-1.114-2.057 2.395-1.27.96-.32 2.24-1.106.64-2.854.64-1.426 4.48.95 7.347 1.107 3.354 1.27 1.28 2.853-.156 4.124-3.994 1.58-2.713.48 3.992 2.696-4.79.154-13.424 2.195-1.383.657-7.408 6.654-9.586 3.173-1.116 1.427-1.755 4.754 1.114 2.377 1.435.796-3.993 3.97-2.396 2.387 4.16z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Nepal" } }, [
              _c("title", [_vm._v("Nepal")]),
              _c("path", {
                attrs: {
                  id: "154",
                  d:
                    "M595.182 448.79l.397 3.69 6.982 3.162 11.193.83-.423-2.705-7.478-2.058-6.346-3.778-4.326.857z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "New Zealand" } }, [
              _c("title", [_vm._v("New Zealand")]),
              _c("path", {
                attrs: {
                  id: "163",
                  d:
                    "M804.22 655.73l.918 10.198-1.228 4.634-4.6 3.396.305 4.02v4.322l1.228 1.548 12.577-10.814v-2.472h-3.068l-4.298-14.52-1.833-.313zM795.023 677.98l2.455 4.632-6.752 6.492-.613 3.396-4.6.613-7.667 7.104-7.054-3.396-.613-2.473 12.878-5.558 11.965-10.81z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Oman" } }, [
              _c("title", [_vm._v("Oman")]),
              _c("path", {
                attrs: {
                  id: "151",
                  d:
                    "M532.244 481.88l6.388-3.684 1.133-5.402-1.4-.804.58-5.792 1.22-.71 1.305 2.05 7.77 4.062v2.258l-9.412 13.854-4.33.147-3.254-5.98z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Panama" } }, [
              _c("title", [_vm._v("Panama")]),
              _c("path", {
                attrs: {
                  id: "177",
                  d:
                    "M205.68 506.748l-1.262 3.94 4.167 1.08 2.584.512.44-3.052 2.775-1.4 2.463 1.27.968 1.548 1.175-.138.926-2.81-3.078-1.27-2.334-1.272-2.333 1.59-2.774 1.4-2.835-1.14-.88-.258z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Peru" } }, [
              _c("title", [_vm._v("Peru")]),
              _c("path", {
                attrs: {
                  id: "180",
                  d:
                    "M209.518 541.246l-1.677 1.695.114 2.704 14.643 26.694 15.205 9.802 2.35-3.94.563-8.67-1.228-5.402-4.14-6.984-2.464.786-1.115 1.236-4.918-5.636 1.228-6.647 5.705-3.717-.45-3.492-5.808-.226-3.017-5.064-1.677-.562.114 3.044-7.486 8.895-5.593-1.348-.347-3.166z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Papua New Guinea" } }, [
              _c("title", [_vm._v("Papua New Guinea")]),
              _c("path", {
                attrs: {
                  id: "178",
                  d:
                    "M778.176 546.008l-.82.19-.5 2.223-1.573 1.022-4.73.83.19 1.78 4.98-.25 3.155-1.972-.188-3.432-.514-.39zM776.093 540.797l-.762 1.08 4.16 3.683.57 2.16 1.132-.13.13-2.22-1.263-1.14-3.967-3.433z M752.132 540.183l-.32 21.126 3.045-.165 4.002-4.676 3.36.163 2.16 1.937.72 5.964 6.88 3.63 1.764-.647v-2.18l-5.523-4.598-2.722-6.294 2.16-1.047-1.6-3.467-3.197-.078-.804-3.71-8.48-5.72-1.444-.242z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Philippines" } }, [
              _c("title", [_vm._v("Philippines")]),
              _c("path", {
                attrs: {
                  id: "181",
                  d:
                    "M697.337 496.306l-.743 1.418-.414 1.746-4.132 5.246.25 1.08 1.737-.25 5.368-6-2.066-3.24zM704.027 494.31l-.088 4.33 1.572 1.582.578 3.077 1.574.336.742-1.92-1.236-.915-.328-5.41-2.815-1.08zM708.496 495.978l-.087 3.83.907 1.494 1.57-1.832-.413-3.328-1.978-.164zM709.48 492.64l1.573 2.084.743 1.997h1.41l-.25-3.414-1.574-1.08-1.9.415zM712.542 500.472l.328 2.498-2.896 2.334-2.396.25-2.56 2.75.087 1.252 2.396-.75 1.652-1.08 1.408 3.577 2.48 1.747.994-.338.907-1.08-1.978-1.997 1.16-.916 1.32 1.08.907-1.496-.907-1.833-.164-4.08-2.738-1.918zM699.074 475.076l-2.23 1.58-.25 4.998 3.477 6.742 1.16.915 1.484-1.002 2.56.415.492 2.248 1.9.165.91-1.245-1.16-1.582-1.408-1.33-2.974-.328-1.573-2.585 1.817-2.75.163-2.41-1.236-3.077-3.13-.752zM700.232 489.98l.657 2.334 1.157.752.83-1.08-1.323-1.833-1.322-.174z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Pakistan" } }, [
              _c("title", [_vm._v("Pakistan")]),
              _c("path", {
                attrs: {
                  id: "176",
                  d:
                    "M553.638 455.082l2.248 3.337-.216 1.72-2.99 1.185-.218 2.8h3.424l1.175-.968h6.52l5.878 5.17.752-2.48h4.383l.104-3.12-4.486-4.306.96-2.368 4.6-.318 6.198-12.924-3.425-2.688-1.278-4.52 8.333-.753-4.917-7-2.62-.71-1.07 1.297-.804.06-4.92 3.12 1.61 2.697-1.816 1.937-2.25 8.29-5.557 3.554-.752 3.882-8.862 3.106z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Poland" } }, [
              _c("title", [_vm._v("Poland")]),
              _c("path", {
                attrs: {
                  id: "183",
                  d:
                    "M457.11 390.184l.732 1.348.174 1.435-.604 1.392-1.383 2.663-1.168.526-1.514-.658-.908.043-2.204.83-2.506-.742-4.062-2.88-3.978-2.134-1.6-2.44-.303-5.75 3.112-2.704 4.06-1.35 1.33-.138.314 1.007 1.725.692 4.765.09 1.47-.043 2.42 3.708-.603 1.52.26 1.79.467 1.792z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Puerto Rico" } }, [
              _c("title", [_vm._v("Puerto Rico")]),
              _c("path", {
                attrs: {
                  id: "187",
                  d:
                    "M249.297 482.068l-2.282-.77-1.833 1.15.917 1.07 3.12.458.077-1.908z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Portugal" } }, [
              _c("title", [_vm._v("Portugal")]),
              _c("path", {
                attrs: {
                  id: "184",
                  d:
                    "M367.834 443.48l-.934 1.186.934 1.185 1.408-.708-1.408-1.66zM337.112 426.713l-1.175 1.184 2.107 1.185.234-1.65-1.166-.72zM343.448 426.004l-1.408.94 1.175.942 1.876-.476-1.642-1.406zM344.382 429.314l-.7 1.892.935 1.185 1.175-.94-1.41-2.136zM350.01 433.092l-.467 1.184.7.71 1.876-1.185-2.11-.708z M387.5 421.716l-.537 7.478-1.53 1.384.156.846 1.07 1.772-.69 2.16 1.148.39 2.68-.312-.155-2.16 1.756-10.02-.383-1.383-3.518-.154z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Paraguay" } }, [
              _c("title", [_vm._v("Paraguay")]),
              _c("path", {
                attrs: {
                  id: "179",
                  d:
                    "M267.2 584.458l1.9 2.074-.224 4.392 5.48-.338 4.14 5.3-.336 4.728-2.68 4.054-5.48.225-.225-2.256 1.564-3.718-5.37-3.38h-4.468l-3.354-3.605 2.438-6.968 6.613-.51z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Qatar" } }, [
              _c("title", [_vm._v("Qatar")]),
              _c("path", {
                attrs: {
                  id: "188",
                  d:
                    "M527.273 463.018l-.45 3.467 1.332 1.012 1.21-.112.45-4.365-1.048-.752-1.494.75z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Romania" } }, [
              _c("title", [_vm._v("Romania")]),
              _c("path", {
                attrs: {
                  id: "190",
                  d:
                    "M457.73 401.28l-.225 1.28-5.005 4.166 4.184 6.137 2.682 1.877h4.823l1.59-1.33 2.135-.277 1.59.96 2.82-3.208-.546-1.607-2.862-.734-1.953-.095.094-2.75-2.594-4.08-6.735-.34z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Serbia" } }, [
              _c("title", [_vm._v("Serbia")]),
              _c("path", {
                attrs: {
                  id: "206",
                  d:
                    "M452 407.28l-1.77 1.33h-.864l-.588 1.833 2.092 2.43.14 1.928-.883 1.247 3.068 3.197 3.317-1.012-.274-4.72-4.237-6.233z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Russian Federation" } }, [
              _c("title", [_vm._v("Russian Federation")]),
              _c("path", {
                attrs: {
                  id: "191",
                  d:
                    "M450.108 378.288l-1.296 2.396 4.665.043h.95l-.18-1.352-.727-.854-3.412-.232zM741.137 353.246l-1.07 1.332.086 2.083.992-.085 1.65-2.913-1.658-.416zM776.793 272.303l-2.04 1.33-.483 1.695.96 1.09 2.16-.727 2.16.727 1.202.363-.12-3.994-3.84-.483zM488.54 272.648l1.486.598-1.046 1.798v2.55l-2.23 1.35h-2.377l-1.34-1.65.146-1.8 1.045-1.35h2.084l2.23-1.496zM494.192 270.998v1.798l1.486 1.202 2.083-.146 1.79-1.65v-1.203h-1.635l-1.34.448-1.046-1.2-1.338.75zM502.68 271.152l1.047 2.248 2.084.147 1.487-.596-.742-2.1-1.937-.45-1.937.752zM511.16 268.154l-1.634-.303-1.487 1.505.743 1.35.45 2.1 1.936-1.496.448-1.65-.457-1.506zM520.237 284.05l-.45 2.1-3.424 3-7.294 1.652-5.958 9.897-1.046 2.852 5.957 1.505.89-3.597 1.79-5.55 4.614-2.402 3.872-3 2.825-1.2h1.487v-4.047l-3.265-1.21zM501.04 305.946l4.018.45 1.342 4.65 3.423 3.596-1.193 2.402h-2.083l-1.937-2.248-4.313-.146-1.79-2.403v-1.65l2.683-.753-.15-3.898zM563.855 254.81l-1.938-1.204h-2.23l-.448 1.35-2.378 1.35-1.79.596-.294 1.798 4.167.303 4.91-4.194zM568.463 255.257l-1.047 2.247-2.083-.146-3.276 2.402-.89 3h2.083l1.193-1.953 2.826 2.1 2.68-1.2 1.937-1.65-.744-2.552-1.046-1.798-1.634-.45zM572.784 256.908l1.046 4.2 1.634 3.898 1.79-3.146 3.423-.752v-2.248l-2.23-1.65-5.663-.302zM654.453 250.184l2.326 1.953 1.648-.683.484-2.74-3.39-2.342-2.23 1.47-5.427.492v2.445l-5.724.095v4.002l6.69 4.98 1.748-1.272-.39-3.52 4.27-1.07-.873-1.66-1.547-1.563 2.415-.588zM660.66 247.84l1.547 2.932 6.017-.684 1.65-2.152-.39-1.857-1.65-.685-1.547 1.176-4.46.98-1.167.29zM660.27 259.268l-3.01-.777-1.735 1.858-.778 2.54 4.07-.388 3.105-1.564-1.65-1.668zM738.23 242.37l-2.522-.78-2.904 1.073-1.453 2.15 1.843 2.447 4.85-2.15.968-1.073-.78-1.668zM739.156 358.33v3.664l1.16.415.827-1.333v-2.827l-1.987.08zM705.35 345.086l-.076 5.333 6.69 10.33 2.395 8.988 4.218 7.996 1.65.58 1.408-1.168.657-1.918-6.033-6.578.164-3.416 1.322-.578.33-1.997-11.817-16.736-.91-.838zM751.967 328.516l-1.65.164.994 1.418 2.066 1.418.58-.666-1.99-2.334zM755.183 329.52l.25 1.416 2.56.752.252-1.002-3.062-1.166zM769.23 334.956l1.08 1.937 1.8-.12.36-1.333-3.24-.484zM787.356 337.98l1.442 2.662 1.08-1.21v-1.814l-2.522.362z M722.06 302.16l1.52 5.256 3.044.873 3.042-4.815-1.737-3.285.647-2.845h4.563l-1.09 2.188.434 7.883-6.52 16.2.65 3.5-.217 5.912 12.16 17.73 2.388.656.216-14.443 2.387-2.187-2.61-5.688 2.17-2.412-4.78-6.346-2.61.217-.865-10.503 6.734-1.754.432-3.068 3.478-.873 1.953 1.756 2.385-9.63 4.124-7 3.258-1.756 2.827.217v-3.284l-4.563-.873-6.302-5.256 3.044-3.5-2.61-5.913 2.17-2.187 2.61 3.5 6.518 2.41 7.166.658.873-3.06-3.69-3.718 4.124-5.688-9.345-3.286-2.387 4.814-3.043-3.94-17.158-5.914-16.295 2.844-2.387 1.314v1.313l3.476 1.756-.434 4.158-6.3-2.628-13.9 5.473-2.387-5.03h-9.56l-4.35 4.598-15.42-3.5-14.116 2.844-1.738 4.375 2.17.655-.216 3.285-13.685 1.53.874 4.374-12.604-2.188 3.044-5.688-12.82-.657 1.09 5.914-4.123 1.97-3.475-3.284-14.116 2.412-5.43 5.03-.216 3.06-3.476.217-.433-3.5 11.082-9.63v-6.57l-7.166-1.97-9.344 3.06-3.907-3.942h-1.738l-2.17 4.374 1.737 1.97-12.39 6.788-10.64 8.1-6.52 8.972v3.717l6.95 2.844-3.476 2.627-7.382-2.626-3.044 2.627-4.563-5.255-.873 1.972 4.996 15.758 1.305.44 3.478-1.754 1.737 1.314v2.844l-3.26-1.313-1.954 1.53 1.308 2.843-1.09 7.443-6.733.658-.432-2.412 3.907-2.41.873-6.57-4.35-5.69-1.52-9.845-6.948-1.097-.648 3.5 1.304 1.754-2.825 2.412 1.088 6.57 4.124 1.754.873 4.814-4.133-2.627-10.64-1.97-1.307 3.5-8.473 3.06-1.305-2.186-11.082 6.127-.216 4.16-4.35.656 1.307-3.06v-3.06l-4.35-1.53-2.825 1.098 2.386 4.6 1.737 3.06v2.41l-3.26-.655-.647-.658-3.26 3.5 1.737 3.062-7.383-.217 2.387 3.07-.648 1.312h-3.907l-2.827-1.972-.647-5.472-4.562-1.755v-2.186l9.56 1.972 5.214.44 2.17-3.285-1.954-3.5-13.9-5.472-4.797 1.192-1.64 1.41.51 3.24 2.04.354-.477 5.1 6.293 14.782-4.548 7.21-.312 1.624 2.31 1.625-2.085 1.375-1.382.026.26 6.353 1.91 2.705.026 2.627 2.446.225 3.74 1.426 3.96 5.446.045 1.434-1.288 2.205 2.956-.165 2.878.83 3.892 5.506 9.577.874-.416 6.552-3.3 2.827.682 1.105-3.26 3.502-.864 3.284 1.954 2.845 6.3 2.186 2.612-1.53 16.727 6.346.648-1.756-3.476-3.283v-4.158l-2.17-.657.433-3.5 3.476-4.158-6.23-4.667.43-6.492 6.666-4.382 7.822.44 1.306 2.413 8.04.44 5.87-3.283-3.045-3.285.647-6.13 15.205-7.44 11.695 5.27 3.907-3.5 11.513 10.943 8.688-.873 3.045 3.06 8.255.873 5.43-7.44 6.948 3.067 3.69.658 3.692-3.285-3.26-2.188 2.827-4.374 8.04 2.628 1.735 3.502 3.477.216 2.17-1.53 5.868-.216.647 1.53 6.733.44 4.562-4.814 9.345 1.098 2.827-1.098.864-5.256-2.826-6.346 2.826-2.41h8.904l8.47 10.068 10.858 6.13h3.26l.432-2.628 3.907-2.412.433 14.228-3.475.216v3.5l1.953 2.412-.363 3.13 1.443.597.874-2.188 1.306.44.864.873 3.907-.873 3.905-11.385.434-14.23-4.997-11.384-6.3-7.656-3.045.44v2.412l-7.382-2.845 2.826-6.127 2.387-16.2 9.99-3.06 4.78-3.06h5.213l-1.312 1.755 1.307 2.188 4.563-4.814 2.61.215-.433-2.844-4.132-.873 2.827-10.287 3.737-3.523z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Rwanda" } }, [
              _c("title", [_vm._v("Rwanda")]),
              _c("path", {
                attrs: {
                  id: "193",
                  d:
                    "M479.896 532.93l2.43 2.24-.105 2.395-3.768.077v-2.646l1.444-2.065z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Saudi Arabia" } }, [
              _c("title", [_vm._v("Saudi Arabia")]),
              _c("path", {
                attrs: {
                  id: "204",
                  d:
                    "M519.812 458.02l6.06 8.444 1.954 1.558.874 3.785 9.327.734 1.055.555-1.046 4.667-6.13 3.613-8.963 2.715-4.78 4.668-5.68-3.312-3.438 3.01-4.79-7.824-3.285-1.504-1.192-1.807v-3.915l-11.954-14.452-.45-2.56h3.44l4.183-3.612.146-1.807-1.192-1.2 2.396-1.954 5.084.302 8.67 7.226 5.116-.232.33 1.263 4.266 1.64z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Solomon Islands" } }, [
              _c("title", [_vm._v("Solomon Islands")]),
              _c("path", {
                attrs: {
                  id: "29",
                  d:
                    "M783.786 549.882l1.072 2.98 1.892 1.843.57-.51-.19-1.972-2.144-2.603-1.2.262zM789.016 554.324l.13 1.97 1.2 1.142 1.135-.7-1.01-2.102-1.454-.31zM790.528 559.218l-1.012 1.08 1.07 1.97 1.263.382-.06-1.33-1.262-2.102zM792.992 558.076l.882 2.16 1.702 2.03.943-1.52-1.264-2.16-2.264-.51zM797.41 561.317l.5 2.67 1.203 1.65 1.01-2.09-2.714-2.23zM798.792 567.29l-.44.76 1.452 1.912 1.012.062-.632-2.482-1.392-.25zM795.576 571.094l-1.514.7 1.323 1.843 1.133-.64-.942-1.903z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Seychelles" } }, [
              _c("title", [_vm._v("Seychelles")]),
              _c("path", {
                attrs: {
                  id: "207",
                  d:
                    "M535.676 548.87l-.525 1.062 1.443 1.192 1.056-1.192-1.974-1.062zM543.05 540.92l-1.583 1.06 1.186 1.858h1.582l-1.186-2.92zM543.706 545.56l-1.055 1.193.787 1.192 1.442.27.13-2.523-1.304-.132z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Sudan" } }, [
              _c("title", [_vm._v("Sudan")]),
              _c("path", {
                attrs: {
                  id: "219",
                  d:
                    "M466.144 505.035l-2.55-1.504-2.325-4.59.13-4.27 3.223-2.772.155-10.228 2.127.062-.242-5.68 22.302.198 3.19-3.215 6.88 11.004-3.77 4.44v6.786l-4.6 9.89-1.04 2.3-3.708-5.315-2.708 3.442-3.06.834-9.94-1-4.334 1.54.268-1.92z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Sweden" } }, [
              _c("title", [_vm._v("Sweden")]),
              _c("path", {
                attrs: {
                  id: "223",
                  d:
                    "M445.898 368.927l-1.824 1.443.917 2.118 1.617-1.573-.71-1.988z M445.232 329.52l1.693 1.563h3.173l1.746 3.354.477 5.748-4.277 3.035v3.033l-3.017 4.158-1.746.155-2.378 3.994.155 3.837 4.124 3.035-.318 1.754-1.582 2.396-2.377 2.074.155 6.872-3.647 1.28-1.27 2.712h-1.747l-.95-4.79-3.968-6.083 3.26-5.455.225-13.477 2.248-1.236.545-7.71 6.405-9.172 3.074-1.078z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Singapore" } }, [
              _c("title", [_vm._v("Singapore")]),
              _c("path", {
                attrs: {
                  id: "209",
                  d:
                    "M658.314 527.705l.686.39 1.548-.127-.13-1.167-1.262.2-.842.705z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Slovenia" } }, [
              _c("title", [_vm._v("Slovenia")]),
              _c("path", {
                attrs: {
                  id: "212",
                  d:
                    "M442.708 405.076l-2.195 1.314-4.097.898.82 2.368 2.87.034 2.646-2.213-.044-2.4z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Slovakia (Slovak Republic)" } }, [
              _c("title", [_vm._v("Slovakia (Slovak Republic)")]),
              _c("path", {
                attrs: {
                  id: "210",
                  d:
                    "M443.607 400.875l.597.527.077.898 6.597-.146 4.875-2.102-.077-2.135-.934.415-1.34-.718-.82-.035-2.16.864-2.94-.71-3.873 3.14z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Sierra Leone" } }, [
              _c("title", [_vm._v("Sierra Leone")]),
              _c("path", {
                attrs: {
                  id: "208",
                  d:
                    "M372.804 509.79l4.884 4.72 3.483-4.227-2.178-3.415-3 .303-3.188 2.62z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Senegal" } }, [
              _c("title", [_vm._v("Senegal")]),
              _c("path", {
                attrs: {
                  id: "205",
                  d:
                    "M372.424 498.77l-5.792-.14 1.072 2.603.596-1.607 7.27.76.807-.027 3.405.12.12-1.505-3.11-3.733-3.467-4.693-2.152-.9-1.66.425-3.406 2.472-.776 1.384-.24 1.384 1.252.9 4.185-.062 2.688-.728.303 1.322-.24 1.746-.854.28z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Somalia" } }, [
              _c("title", [_vm._v("Somalia")]),
              _c("path", {
                attrs: {
                  id: "213",
                  d:
                    "M512.674 502.797l3.526 2.403 1.046-.052 8.757-3.008.994 3.206-.7 2.706-1.894 1.503-4.73-.302-6.768-4.158-.23-2.298z M526.703 501.94l3.777-1.45 1.34.803-.147 3.354-3.482 9.923-18.853 20.19-2.187-1.503-.147-8.52 2.835-3.26 6.018-1.858 8.824-9.32 2.31-2.057.647-3.008-.934-3.294z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Suriname" } }, [
              _c("title", [_vm._v("Suriname")]),
              _c("path", {
                attrs: {
                  id: "220",
                  d:
                    "M268.384 516.715l1.763 1.616 2.73-1.693 2.49.078-.32.968-1.045 2.18-.164 5.42-4.97 2.022.242-3.476-3.207-2.992.164-1.538 2.317-2.585z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "South Sudan" } }, [
              _c("title", [_vm._v("South Sudan")]),
              _c("path", {
                attrs: {
                  id: "217",
                  d:
                    "M489.336 508.02l-2.04.897.647 3.553h2.542l3.448 5.004-2.767.354-.71 1.288-.068 1.857-8.298-.146-.848-1.288-5.8-.33-10.65-10.96 1.064-.64 4.517-1.365 9.897.754 3.366-.755 2.235-2.996 3.466 4.77z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Sao Tome and Principe" } }, [
              _c("title", [_vm._v("Sao Tome and Principe")]),
              _c("path", {
                attrs: {
                  id: "203",
                  d:
                    "M421.91 530.554l.994-.502.743.604-.743 1.148-.9-.354-.093-.896zM423.907 527.398l1.496-.25.5.95-.742.805-.742-.104-.51-1.402z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "El Salvador" } }, [
              _c("title", [_vm._v("El Salvador")]),
              _c("path", {
                attrs: {
                  id: "66",
                  d:
                    "M189.308 495.217l4.062 2.022-.06-3.208-2.084-1.27-1.918 2.455z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Syrian Arab Republic" } }, [
              _c("title", [_vm._v("Syrian Arab Republic")]),
              _c("path", {
                attrs: {
                  id: "225",
                  d:
                    "M487.545 437.18l-.302 2.196 2.437 1.02-.104 6.087 2.438-.053 2.438-1.842.916-.155 5.532-4.398 1.114-6.39-11.056 1.125-1.167 2.56-2.245-.15z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Swaziland" } }, [
              _c("title", [_vm._v("Swaziland")]),
              _c("path", {
                attrs: {
                  id: "222",
                  d:
                    "M482.53 596.983l-2.168.36-.935 2.553 1.66 1.513h2.014l1.703-2.447-2.272-1.98z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Chad" } }, [
              _c("title", [_vm._v("Chad")]),
              _c("path", {
                attrs: {
                  id: "43",
                  d:
                    "M440.97 494.983l.113-2.552 4.098-3.982 1.1-9.785-2.73-5.22 1.91-.98 18.498 9.64-.113 9.455-3.26 2.775v4.875l2.137 4.132h-3.77l-6.24 6.173-.165 1.867-4.605-.06-.06.845-2.63-.345-1.797-3.397-1.35-.666.173-1.037 1.693-1.297v-6.066l-2.342-.363-2.826-2.102 2.17-1.91z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Togo" } }, [
              _c("title", [_vm._v("Togo")]),
              _c("path", {
                attrs: {
                  id: "228",
                  d:
                    "M408.495 516.81l2.316-1.356-.052-8.946-1.504-2.438-.967.812.208 11.928z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Thailand" } }, [
              _c("title", [_vm._v("Thailand")]),
              _c("path", {
                attrs: {
                  id: "227",
                  d:
                    "M646.043 472.915l2.8 3.604v4.383l.968.482 4.453-2.144.873.295 5.316 6.138-.19 4.192-1.737-.294-1.548-.978-1.158.097-2.032 3.403.39 1.85 1.642.874-.095 2.05-1.157.587-3.97-2.73v-2.44l-1.642-.094-.674 1.07-.347 10.91 2.567 4.685 4.547 4.383-.19 1.27-2.422-.093-2.22-3.31h-2.326l-2.902-2.346-.874-2.438 1.254-2.05.432-1.85 1.366-2.42-.06-5.566-3.338-4.823-.14-.588 1.082-1.09-.25-3.83-4.442-5.626.52-3.242 5.503-2.323z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Tajikistan" } }, [
              _c("title", [_vm._v("Tajikistan")]),
              _c("path", {
                attrs: {
                  id: "226",
                  d:
                    "M559.74 422.234l3.552-4.408h1.34l.467.984-1.643 1.192v.985l1.08.777 5.196.312 1.693-.727.77.153.52 1.66 3.085.312 1.55 3.267-.468.985-.614.053-.612-1.245-1.34-.104-2.316.313-.156 2.18-2.316-.155.104-2.75-1.694-1.658-2.575 2.125.053 1.4-2.265.778h-1.34l.104-4.824-2.174-1.606z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Turkmenistan" } }, [
              _c("title", [_vm._v("Turkmenistan")]),
              _c("path", {
                attrs: {
                  id: "236",
                  d:
                    "M528.328 418.56l-.535 2.274h-3.588v3.078l3.854 2.54-1.192 3.483v1.608l1.6.27 2.126-2.812 4.79-1.07 10.233 3.882.13 2.81 5.713.535 6.38-6.698-.796-2.146-4.253-.935-11.963-7.772-.535-2.81h-4.52l-1.998 3.753h-1.997l-3.45.01z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Tunisia" } }, [
              _c("title", [_vm._v("Tunisia")]),
              _c("path", {
                attrs: {
                  id: "233",
                  d:
                    "M425.516 435.624l4.78-1.927 1.572 1.02.06 1.244-.733.96.11 1.703.736.396v3.06l-.846 1.418.11.908 3.208 1.132-2.584 4.02-1.012-.06-.173 3.23-1.124.175-.96-.85.225-3.283-3.146-3.06-.398-2.663 1.52-1.192-1.346-6.23z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Turkey" } }, [
              _c("title", [_vm._v("Turkey")]),
              _c("path", {
                attrs: {
                  id: "235",
                  d:
                    "M472.812 421.906l-2.305-1.426-1.27-1.013-2.14.916-1.476 3.74 2.22-.5 1.562-1.188 3.438.938-1.946 1.877-5.175-.25-1.91 2.093v1.02l1.22 1.022v1.123l-.512 1.332.51 1.123 1.626-.812 1.625 1.738-.407 1.228-.604.82.906 1.02 4.46.917 3.14-1.33v-1.938l1.52.303 3.65 2.144 3.947-.614 1.72-1.633 1.115.406v1.842h1.52l1.314-2.55 11.55-1.23 5.04-.612-1.332-1.746-.025-2.36 1.01-1.21-3.68-2.955.196-2.552h-2.02l-3.355-1.643-1.93 2.04-7.087-.208-4.253-2.55-4.082.367-4.544 2.73-3.238-.418z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Trinidad and Tobago" } }, [
              _c("title", [_vm._v("Trinidad and Tobago")]),
              _c("path", {
                attrs: {
                  id: "231",
                  d:
                    "M258.97 502.572l-.917.847-.994.154v1.228l1.832 1.687.76-1.23.458-1.383-.156-1.15-.984-.155z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Taiwan" } }, [
              _c("title", [_vm._v("Taiwan")]),
              _c("path", {
                attrs: {
                  id: "46",
                  d:
                    "M695.686 453.76l-3.06 2.334-.163 4.494 2.646 3.078.655-.58-.08-9.326z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Tanzania" } }, [
              _c("title", [_vm._v("Tanzania")]),
              _c("path", {
                attrs: {
                  id: "247",
                  d:
                    "M492.22 560.017l13.797-1.69-3.395-6.57-.182-6.29 1.098-3.01-14.367-9.023-4.5.743-1.565 1.158-.14 2.637-1.01 3.656-1.056 1.253-1.515.142 2.81 9.418 4.815 2.838 4.195.1 1.015 4.64z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Ukraine" } }, [
              _c("title", [_vm._v("Ukraine")]),
              _c("path", {
                attrs: {
                  id: "240",
                  d:
                    "M460.662 388.79l-2.507 1.41.622 2.663-2.316 4.884.02 2.15 1.09.692 6.983.345 1.954-1.615 2.092.7 2.998 4-2.194 3.943 2.61.76 3.414-3.932 1.954.355 1.815 1.262-1.6 2.11 2.16 3.37h2.3l1.184-2.248 2.44-.495.068-1.823-4.53-.7.14-1.963h4.392l4.737-3.795 2.092-1.824.344-5.756-9.336-.838-3.83-5.402-2.645-.908-3.207.14-1.443 3.568-6.57.087-2.135-.985-3.096-.154z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Uganda" } }, [
              _c("title", [_vm._v("Uganda")]),
              _c("path", {
                attrs: {
                  id: "239",
                  d:
                    "M480.31 532.23l2.62 2.454 1.643-1.045 4.442-.73.762.08.284-1.688 2.51-5.272-2.11-4.392-6.837.044-.043 1.808.917.882-.14 1.807-4.046 6.05z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "United States of America" } }, [
              _c("title", [_vm._v("United States of America")]),
              _c("path", {
                attrs: {
                  id: "248",
                  d:
                    "M 74.79 285.234 l 2.992 5.594 l 1.92 -0.432 v -1.938 l -4.91 -3.224 z M 57.926 334.428 l -0.147 2.602 l 1.866 -0.432 v -1.158 l -1.72 -1.012 z M 55.057 335.586 l -3.734 1.885 l 0.58 2.023 l 1.434 -1.158 l 2.87 -1.306 l -1.15 -1.444 z M 39.54 338.042 l -2.583 -0.58 l -0.432 1.16 l 0.285 2.168 l 2.73 -2.748 z M 34.078 337.902 l -2.446 -1.01 l -0.865 1.59 l 1.582 1.59 l 1.728 -2.17 z M 95.485 277.922 l -7.252 1.72 l 1.496 8.17 l 7.89 2.15 l 0.424 1.72 l -11.73 3.657 L 79.7 306.3 l 2.344 11.608 l 3.838 2.576 l 2.99 -2.793 l 0.857 1.722 l -3.63 4.296 l -14.083 6.45 l -8.964 2.15 l -0.216 3.225 l 20.694 -6.016 l 8.533 -2.37 l 7.892 -9.673 l 8.748 -5.8 l -4.478 7.52 l 4.91 0.648 l 8.324 -3.656 l 1.495 6.017 l 5.757 1.288 l 5.973 5.8 l 0.423 4.297 l -0.855 1.072 l 1.063 4.08 h 1.496 l 0.216 -6.882 h 1.703 l 0.424 16.977 l 4.27 -3.657 l -2.99 -17.625 h -4.478 l -4.91 -6.23 l 24.108 -40.845 l -23.892 -18.696 l -26.667 5.16 l -1.063 8.17 l 5.757 3.438 l -2.136 5.594 l -7.67 -6.222 z M 143.59 375.99 l -0.866 3.474 l -3.017 -1.954 h -1.504 l -0.865 3.69 l -10.554 23.65 l 2.8 20.607 l 3.45 1.737 l 0.648 5.645 h 7.105 l 6.89 5.203 l 13.56 1.305 l 1.505 6.94 l 2.152 1.522 l 3.017 -3.033 l 2.37 1.08 l 2.152 9.976 l 3.656 2.386 l 3.017 -5.646 l 9.258 -6.726 l 6.025 2.817 l 5.17 0.433 l 0.215 -3.25 l 10.762 0.217 l 2.152 2.386 l 0.432 5.42 l -1.29 3.035 l 1.505 5.203 h 3.233 l 3.232 -4.987 l -1.288 -2.385 l -1.288 -5.204 l 1.936 -5.86 l 8.826 -7.59 l 6.673 -1.952 l -0.865 -6.293 l 9.258 -9.983 l 9.258 -1.52 l -1.503 -5.194 l 9.042 -5.205 v -6.94 l -0.866 -0.433 l -3.233 1.082 l -0.43 4.252 l -10.746 0.13 l -8.42 5.593 l -13.216 4.322 l -2.11 -2.587 l 6 -9.076 l -2.965 -2.826 l -2.014 -3.837 l -4.176 -3.354 l -4.538 -0.38 l -8.575 -5.853 l -60.97 -10.038 z M 3 422 L 5 421 L 6 422 l -1 3 l -2 -1 l 0 -2"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Uruguay" } }, [
              _c("title", [_vm._v("Uruguay")]),
              _c("path", {
                attrs: {
                  id: "251",
                  d:
                    "M274.633 612.48l-1.773 1.895.735 10.183 5.566 1.615 7.08-7.097-11.607-6.595z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Uzbekistan" } }, [
              _c("title", [_vm._v("Uzbekistan")]),
              _c("path", {
                attrs: {
                  id: "252",
                  d:
                    "M558.643 428.477l2.662.138v-4.556l-2.522-1.47 4.253-5.36h1.73l1.728 2.016 4.52-1.738-6.25-2.144-.24-1.297-1.486.363-1.46 2.54-6.303-.206-4.625-6.543-8.125.804-3.872-3.838-5.358-.906-3.89 1.582 2.256 7.502.025 2.524 1.643.035 2.014-3.84 5.36.07.795 2.946 11.487 7.624 4.442 1.02 1.217 2.733z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Saint Vincent and the Grenadines" } }, [
              _c("title", [_vm._v("Saint Vincent and the Grenadines")]),
              _c("path", {
                attrs: {
                  id: "201",
                  d:
                    "M258.823 496.582l-1.063.77.84 1.54 1.373-.77-1.15-1.54zM257.526 499.573l-.994.994.38.612h1.22l.38-1.004-.986-.603z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Venezuela" } }, [
              _c("title", [_vm._v("Venezuela")]),
              _c("path", {
                attrs: {
                  id: "253",
                  d:
                    "M231.5 503.558l.38 2.24 2.81.89.64-4.123 2.964-3.068 2.965 3.475 6.82 1.86 5.773-1.212 3.933 4.85 2.965 1.857-3.25 4.953 1.09 3.752-1.858 2.3-1.928 1.615-4.175-2.102-.96.97v2.99l3.052 1.45-2.248 2.43-2.248 2.43-2.965-.24-2.98-3.276-.632-12.327-10.183-3.476-1.85-5.42 1.885-2.82z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Vietnam" } }, [
              _c("title", [_vm._v("Vietnam")]),
              _c("path", {
                attrs: {
                  id: "211",
                  d:
                    "M659.035 502.287l1.027 1.616.19 1.85 2.705.295 3.286-4.383 3.095-.873 1.643-4.478-.77-7.21-3.19-4.383-3.36-2.687-4.28-7.35 3.07-5.134-4.394-5.04-3.517-.154-3.165 1.702.942 4.07 4.22.744 1.132 3.138-1.488.97.096.776 9.896 9.683.388 2.843-.595 8.99-6.932 5.014z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Vanuatu" } }, [
              _c("title", [_vm._v("Vanuatu")]),
              _c("path", {
                attrs: {
                  id: "162",
                  d:
                    "M811.006 582.48l-1.07 1.434.45 1.616.534.362.98-1.262-.894-2.15zM811.542 586.88l.087 1.166 1.157.363.805-.45-.805-1.264-1.245.183zM813.236 597.303l-.536.812.804.897 1.34-.448-1.608-1.26z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Yemen" } }, [
              _c("title", [_vm._v("Yemen")]),
              _c("path", {
                attrs: {
                  id: "256",
                  d:
                    "M533.315 498.138l1.842 2.06 2.49-1.505.896-.304-1.14-1.106-2.19.647-1.898.208z M509.432 489.13l1.244 3.7v3.614l2.99 2.714 21.075-8.584.2-2.36-3.382-6.066-8.48 2.706-4.865 4.787-5.645-3.335-3.136 2.826z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "South Africa" } }, [
              _c("title", [_vm._v("South Africa")]),
              _c("path", {
                attrs: {
                  id: "214",
                  d:
                    "M476.73 588.02l-6.828 6.31-1.625 3.9-5.41-.675-4.504 4.002-2.99-.294.24-5.53-1.062-.373-.742 11.314-5.308-.052-1.6-1.886-2.344-.024 2.137 6.13 3.812 3.603-2.723 3.172 1.764 3.977 4.08 1.558 3.25-2.767 9.31.053.668-.83 4.132-.728 13.978-13.917-.053-4.382-1.494 1.938h-2.238l-2.723-2.282 1.383-3.44 2.378-.482-.217-7.07-5.27-1.224zm-3.275 15.99l1.306-.05 2.12 2.298-.062 2.662-2.48 1.253-.156.883-3.785.043-1.186-2.854 1.082-2.092 3.163-2.143z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Zambia" } }, [
              _c("title", [_vm._v("Zambia")]),
              _c("path", {
                attrs: {
                  id: "257",
                  d:
                    "M459.78 571.656l2.74 3.802 4.243.26 1.504.83 4.443.053 3.83-5.366 10.7-4.79.935-4.218-1.244-6.043-5.583-3.18-3.727.26-1.857 4.113.053 1.876 4.39 2.136.26 4.642-3.774.208-.935-1.564-10.495-4.48-.31 3.44-4.963.156-.21 7.866z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ]),
            _c("g", { attrs: { id: "Zimbabwe" } }, [
              _c("title", [_vm._v("Zimbabwe")]),
              _c("path", {
                attrs: {
                  id: "215",
                  d:
                    "M468.52 578.226l7.755 8.757 5.946 1.513 3.985-6.248-.312-8.28-6.465-3.338-2.43 1.098-3.62 5.524-5.015-.053.157 1.026z"
                },
                on: {
                  mouseover: function($event) {
                    return _vm.hoverIn($event)
                  },
                  mouseout: function($event) {
                    return _vm.hoverOut($event)
                  }
                }
              })
            ])
          ]
        )
      ])
    ]),
    _c("div", { staticClass: "map-actions-wrapper" }, [
      _c("div", { staticClass: "report-period" }, [
        _c("div", { staticClass: "period-container" }, [
          _c(
            "div",
            {
              class: _vm.activePeriod === "last30days" ? "active" : "",
              on: { click: _vm.last30days }
            },
            [_vm._v(_vm._s(_vm.$t("homePage.last30Days")))]
          ),
          _c(
            "div",
            {
              class: _vm.activePeriod === "last90days" ? "active" : "",
              on: { click: _vm.last90days }
            },
            [_vm._v(_vm._s(_vm.$t("homePage.last90Days")))]
          )
        ]),
        _c("div", { staticClass: "active-container" }, [
          _c("div", { staticClass: "active-item" }, [
            _c("div", { staticClass: "color most-active" }),
            _c("div", { staticClass: "active-text" }, [
              _vm._v(_vm._s(_vm.$t("homePage.mostActive")))
            ])
          ]),
          _c("div", { staticClass: "active-item" }, [
            _c("div", { staticClass: "color medium-active" }),
            _c("div", { staticClass: "active-text" }, [
              _vm._v(_vm._s(_vm.$t("homePage.mediumActive")))
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "project-data-container" }, [
        _c("p", [_vm._v(_vm._s(_vm.$t("homePage.stayInformed")))]),
        _c("div", { staticClass: "under-description-container" }, [
          _vm.activePeriod === "last30days"
            ? _c(
                "div",
                {
                  class: [
                    "dive-in-button",
                    {
                      subscribed: _vm.isSubscribed30,
                      processing: _vm.isProcessing
                    }
                  ],
                  style: { pointerEvents: _vm.isProcessing ? "none" : "auto" },
                  on: { click: _vm.subscribeClicked }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.isProcessing
                          ? _vm.$t("loading")
                          : _vm.isSubscribed30
                          ? _vm.$t("homePage.subscribed")
                          : _vm.$t("homePage.subscribe")
                      ) +
                      " "
                  )
                ]
              )
            : _c(
                "div",
                {
                  class: [
                    "dive-in-button",
                    {
                      subscribed: _vm.isSubscribed90,
                      processing: _vm.isProcessing
                    }
                  ],
                  style: { pointerEvents: _vm.isProcessing ? "none" : "auto" },
                  on: { click: _vm.subscribeClicked }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.isProcessing
                          ? _vm.$t("loading")
                          : _vm.isSubscribed90
                          ? _vm.$t("homePage.subscribed")
                          : _vm.$t("homePage.subscribe")
                      ) +
                      " "
                  )
                ]
              )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }